let currentStep = 1;
// Add at the top with other global variables
// let userLoggedIn = false;
// let currentUser = null;
let travellers = []; // Array to store multiple travellers
let currentEditingIndex = -1; // -1 means new traveller, >= 0 means editing existing
const additionalDays = 1; // Can be 1, 2, 3, or 4 - adjust minimum selectable date

// API Configuration
const API_CONFIG = {
  API_KEY: "caab6668-d9aa-4bd0-9c05-785e5341d39c", // Add your API key here
  SECRET: "79a02f58527945d8b8ee742dd9305ee3",  // Add your secret key here
  API_URL: "https://azcms.matrix.co.in", // Add your API URL here
  API_ENDPOINT: "/shopify/visa/fetchPassportDetails",
  SAVE_TRAVELLER_ENDPOINT: "/shopify/visa/saveTravellerDetails",
  GET_TRAVELLER_LIST: "/shopify/visa/fetchTravellerDetails",
  EDIT_TRAVELLER:"/shopify/visa/editTravellerDetail",
  DELETE_TRAVELLER:"/shopify/visa/removeTravellerDetail",
  SEND_OTP: "/shopify/visa/sendOtp",
  VERIFY_OTP: "/shopify/visa/verifyOtp"
};

// Store uploaded files
let uploadedFiles = {
  passportFront: null,
  passportBack: null,
  travellerImage: null,
};

// Store selected data
let selectedData = {
  "visitType": "Tourist"
}

// store signup form action
const signupForm = document.getElementById("signupForm");
let shopifyOriginalOnSubmit = signupForm.onsubmit;

// prevent default sign up to call OTP Api
signupForm.onsubmit = function (e) {
    e.preventDefault(); 
};

// Progress saving and restoration functionality
function saveProgress() {
  let existingVariantId = ""
  try{
    existingVariantId = progressData?.formData?.selectedVariantId ?? "";
  }
  catch(e11){
    console.log('progressData is not defined')
  }
  const progressData = {
    currentStep: currentStep,
    travellers: travellers, // Save all travellers
    isUserLoggedIn: userLoggedIn, // Save login state
    formData: {
      // Step 1 data
      title: document.getElementById("title")?.value || "",
      firstName: document.getElementById("firstName")?.value || "",
      middleName: document.getElementById("middleName")?.value || "",
      lastName: document.getElementById("lastName")?.value || "",
      gender: document.getElementById("gender")?.value || "",
      dob: document.getElementById("dob")?.value || "",
      occupation: document.getElementById("occupation")?.value || "",
      mobile: document.getElementById("mobile")?.value || "",
      email: document.getElementById("email")?.value || "",
      passportNumber: document.getElementById("passportNumber")?.value || "",
      passportExpiry: document.getElementById("passportExpiry")?.value || "",

      // Add key for the selected variant id. if nothing present, keep it what existing was. If it was nothing, make it ""
      selectedVariantId: $('.visa-card-active').data('variantId')?.toString() ?? existingVariantId ?? "",
      
      travelStartDate: document.getElementById("travelStartDate")?.value || "",
      travelEndDate: document.getElementById("travelEndDate")?.value || "",
    },
    uploadStates: {
      travelerPhotoUploaded:
        document
          .getElementById("travelerPhotoUpload")
          ?.classList.contains("uploaded") || false,
      passportFrontUploaded:
        document
          .getElementById("passportFrontUpload")
          ?.classList.contains("uploaded") || false,
      passportBackUploaded:
        document
          .getElementById("passportBackUpload")
          ?.classList.contains("uploaded") || false,
    },
    uploadedFileNames: {
      travelerPhotoName: uploadedFiles.travellerImage?.name || "",
      passportFrontName: uploadedFiles.passportFront?.name || "",
      passportBackName: uploadedFiles.passportBack?.name || "",
    },
    uploadedImages: {
      travelerPhotoBase64: uploadedFiles.travellerImage_base64 || "",
      passportFrontBase64: uploadedFiles.passportFront_base64 || "",
      passportBackBase64: uploadedFiles.passportBack_base64 || "",
    },
    timestamp: new Date().toISOString(),
    completed: false,
  };

// CommentedRishabh's Code for traveller error handling
       // ALWAYS save progress (no useless travellers condition)
/*try {
  const dataToStore = JSON.stringify(progressData);

  window.savedVisaProgress = dataToStore;

  try {
    localStorage.setItem("uaeVisaProgress", dataToStore);
  } catch (e) {
    try {
      sessionStorage.setItem("uaeVisaProgress", dataToStore);
    } catch (e2) {
      console.warn("Browser storage not available, using memory only");
    }
  }
} catch (error) {
  console.warn("Could not save progress:", error);
}
*/

  if (travellers.length > 0) {
    try {
      const dataToStore = JSON.stringify(progressData);
      window.savedVisaProgress = dataToStore;

      try {
        localStorage.setItem("uaeVisaProgress", dataToStore);
      } catch (e) {
        try {
          sessionStorage.setItem("uaeVisaProgress", dataToStore);
        } catch (e2) {
          console.warn("Browser storage not available, using memory only");
        }
      }
    } catch (error) {
      console.warn("Could not save progress:", error);
    }
    return;
  }
  // Check if there's any actual progress to save
  const hasFormData = Object.values(progressData.formData).some((value) => {
    if (typeof value === "boolean") return value === true;
    return value && value.trim().length > 0;
  });
  const hasUploads = Object.values(progressData.uploadStates).some(
    (value) => value === true
  );

  // Only save if user has made some progress
  if (!hasFormData && !hasUploads) {
    return; // Don't save empty progress
  }

  try {
    const dataToStore = JSON.stringify(progressData);
    // Store in memory object
    window.savedVisaProgress = dataToStore;

    // Try to save to localStorage first
    try {
      localStorage.setItem("uaeVisaProgress", dataToStore);
    } catch (e) {
      // If localStorage fails, try sessionStorage
      try {
        sessionStorage.setItem("uaeVisaProgress", dataToStore);
      } catch (e2) {
        // If both fail, just use memory storage
        console.warn("Browser storage not available, using memory only");
      }
    }
  } catch (error) {
    console.warn("Could not save progress:", error);
  }
}

function loadProgress() {
  try {
    let savedData = window.savedVisaProgress;
    console.log("LOADING DATA ",savedData);
    // Try localStorage first 
    if (!savedData) {
      try {
        savedData = localStorage.getItem("uaeVisaProgress");
      } catch (e) {
        // If localStorage fails, try sessionStorage
        try {
          savedData = sessionStorage.getItem("uaeVisaProgress");
        } catch (e2) {
          // Both failed, no saved data
          savedData = null;
        }
      }
    }

    if (!savedData) return null;

    const progressData = JSON.parse(savedData);

    // Check if progress is recent (within 7 days) and not completed
    const savedDate = new Date(progressData.timestamp);
    const daysDiff = (new Date() - savedDate) / (1000 * 60 * 60 * 24);

    if (daysDiff > 7 || progressData.completed) {
      clearSavedProgress();
      return null;
    }

    return progressData;
  } catch (error) {
    console.warn("Could not load progress:", error);
    clearSavedProgress();
    return null;
  }
}

function restoreProgress(progressData) {
   console.log("Restore Progress",progressData);
   
   if(progressData){
     const diffDays = getDateDifferenceInDays(progressData.formData.travelStartDate, progressData.formData.travelEndDate);
     if (diffDays === null) return;
    //  selectedData['travelDays'] = diffDays <= 30 ? 30 : 60;
     selectedData['travelDays'] = diffDays;
    //  filterCard(progressData.formData.dob);
   }

  // Restore travellers array
  if (progressData.travellers && Array.isArray(progressData.travellers)) {
    travellers = progressData.travellers;
  }
  // Restore login state
  if (progressData.isUserLoggedIn) {
    userLoggedIn = progressData.isUserLoggedIn;
  }
  // Restore form data
  const formData = progressData.formData;
  Object.keys(formData).forEach((key) => {
    const element = document.getElementById(key);
    if (element) {
      if (element.type === "checkbox") {
        element.checked = formData[key];

        // IMPORTANT: Trigger change event for skipPassportUpload
        if (key === "skipPassportUpload" && formData[key] === true) {
          const passportUploads = document.getElementById("passportUploads");
          const travelerPhotoUpload = document.getElementById(
            "travelerPhotoUpload"
          );
          const personalDetailsSection = document.getElementById(
            "personalDetailsSection"
          );

          if (passportUploads) {
            passportUploads.classList.add("disabled");
          }
          if (travelerPhotoUpload) {
            travelerPhotoUpload.classList.add("disabled");
            travelerPhotoUpload.style.opacity = "0.5";
            travelerPhotoUpload.style.pointerEvents = "none";
          }
          if (personalDetailsSection) {
            personalDetailsSection.style.display = "block";
            const formGrids =
              personalDetailsSection.querySelectorAll(".form-grid");
            const headings = personalDetailsSection.querySelectorAll("h3");
            formGrids.forEach((grid) => (grid.style.display = "grid"));
            headings.forEach((heading) => (heading.style.display = "block"));
          }
        }
      } else {
        element.value = formData[key];
      }
    }
  });

  // Restore upload states
  const uploadStates = progressData.uploadStates;
  const fileNames = progressData.uploadedFileNames || {};
  const uploadedImages = progressData.uploadedImages || {};

  if (uploadStates.travelerPhotoUploaded) {
    const fileName = fileNames.travelerPhotoName || "Photo uploaded";
    markAsUploaded("travelerPhotoUpload", fileName);

    if (uploadedImages.travelerPhotoBase64) {
      uploadedFiles.travellerImage_base64 = uploadedImages.travelerPhotoBase64;
      setFileInputFromBase64(
        "travelerPhotoFile",
        "travelerPhotoPreview",
        uploadedImages.travelerPhotoBase64,
        "traveller-image"
      );
    }
  }
  if (uploadStates.passportFrontUploaded) {
    const fileName = fileNames.passportFrontName || "Passport front uploaded";
    markAsUploaded("passportFrontUpload", fileName);
    if (uploadedImages.passportFrontBase64) {
      // Set passportDataFetched flag to true so that the Passport API is not called again and the existing data is preloaded
      window.passportDataFetched = true;
      uploadedFiles.passportFront_base64 = uploadedImages.passportFrontBase64;
      setFileInputFromBase64(
        "passportFrontFile",
        "passportFrontPreview",
        uploadedImages.passportFrontBase64,
        "passport-front"
      );
    }
  }
  if (uploadStates.passportBackUploaded) {
    const fileName = fileNames.passportBackName || "Passport back uploaded";
    markAsUploaded("passportBackUpload", fileName);
    if (uploadedImages.passportBackBase64) {
       uploadedFiles.passportBack_base64 = uploadedImages.passportBackBase64;
       setFileInputFromBase64(
        "passportBackFile",
        "passportBackPreview",
        uploadedImages.passportBackBase64,
        "passport-back"
      );
    }
  }

  // Handle passport skip state and its UI effects
  const skipCheckbox = document.getElementById("skipPassportUpload");
  const passportUploads = document.getElementById("passportUploads");
  const travelerPhotoUpload = document.getElementById("travelerPhotoUpload");
  const personalDetailsSection = document.getElementById(
    "personalDetailsSection"
  );

  if (formData.skipPassportUpload && skipCheckbox && skipCheckbox.checked) {
    // Apply the skip effects
    if (passportUploads) {
      passportUploads.classList.add("disabled");
    }

    // Disable traveler photo upload
    if (travelerPhotoUpload) {
      travelerPhotoUpload.classList.add("disabled");
      travelerPhotoUpload.style.opacity = "0.5";
      travelerPhotoUpload.style.pointerEvents = "none";
    }

    // Show personal details section with all fields visible
    if (personalDetailsSection) {
      personalDetailsSection.style.display = "block";
      const formGrids = personalDetailsSection.querySelectorAll(".form-grid");
      const headings = personalDetailsSection.querySelectorAll("h3");
      formGrids.forEach((grid) => (grid.style.display = "grid"));
      headings.forEach((heading) => (heading.style.display = "block"));
    }
  } else if (
    uploadStates.travelerPhotoUploaded &&
    uploadStates.passportFrontUploaded &&
    uploadStates.passportBackUploaded
  ) {
    // If all three uploads were completed, show personal details section
    if (personalDetailsSection) {
      personalDetailsSection.style.display = "block";
      const formGrids = personalDetailsSection.querySelectorAll(".form-grid");
      const headings = personalDetailsSection.querySelectorAll("h3");
      formGrids.forEach((grid) => (grid.style.display = "grid"));
      headings.forEach((heading) => (heading.style.display = "block"));
    }
  }

  // preselect the existing variant
  let existingVariantId = progressData?.formData?.selectedVariantId ?? "";
  if (existingVariantId != ""){
    $('.visa-card[data-selected-variant='+existingVariantId+']').addClass('visa-card-active');
  }


  // Restore to saved step
  showStep(progressData.currentStep);
    update();
     requestAnimationFrame(() => {
    filterCard(progressData.formData.dob);
  });
}

function markAsUploaded(elementId, fileName) {
  const element = document.getElementById(elementId);
  if (element) {
    const uploadText = element.querySelector(".upload-text");
    const uploadSubtitle = element.querySelector(".upload-subtitle");

    if (uploadText) {
      // Show "Uploaded: filename" if fileName doesn't already contain it
      if (
        fileName &&
        !fileName.includes("Uploaded:") &&
        !fileName.includes("uploaded")
      ) {
        uploadText.textContent = `Uploaded: ${fileName}`;
      } else {
        uploadText.textContent = fileName || "File uploaded";
      }
    }
    if (uploadSubtitle) {
      uploadSubtitle.textContent = "File uploaded successfully!";
    }
    element.classList.add("uploaded");
  }
}

function clearSavedProgress() {
  try {
    window.savedVisaProgress = null;

    // Clear from both localStorage and sessionStorage
    try {
      localStorage.removeItem("uaeVisaProgress");
    } catch (e) {
      console.warn("Could not clear localStorage");
    }

    try {
      sessionStorage.removeItem("uaeVisaProgress");
    } catch (e) {
      console.warn("Could not clear sessionStorage");
    }
  } catch (error) {
    console.warn("Could not clear progress:", error);
  }
}

function showProgressPrompt(progressData) {
  try{
    let existingVariantId = progressData?.formData?.selectedVariantId ?? "";
    if ($('.visa-card[data-selected-variant='+existingVariantId+']').length == 0){
      return
    }
  }
  catch(e11){
    console.log('Progress prompt hidden, as the selected variant is not present in the visa card list')
  }
  
  const progressDate = new Date(progressData.timestamp).toLocaleDateString();

    const stepNames = {
    1: "Travel Date",
    2: "Travellers Details",
    3: "Type of Visa",
    4: "Upload Documents",
    5: "Review Application",
  };

  const currentStepName = stepNames[progressData.currentStep] || "Unknown Step";
  const travellersCount = progressData.travellers
    ? progressData.travellers.length
    : 0; 
  // FIRST: Make sure travellers array is populated from saved data
  if (progressData.travellers && Array.isArray(progressData.travellers)) {
    travellers = progressData.travellers;
   }

  // Show the saved progress card instead of prompt
  const savedProgressCard = document.getElementById("savedProgressCard");
  const progressDateEl = document.getElementById("progressDate");
  const progressStepEl = document.getElementById("progressStep");
  const progressTravellersEl = document.getElementById("progressTravellers");

  if (
    savedProgressCard &&
    progressDateEl &&
    progressStepEl &&
    progressTravellersEl
  ) {
    // Update text content based on travellers
    if (travellersCount > 0) {
      progressDateEl.textContent = `Last saved: ${progressDate}`;
      progressStepEl.textContent = `Travellers added: ${travellersCount}`;
      progressTravellersEl.textContent = `Total: ${travellersCount}`;
    } else {
      progressDateEl.textContent = `Last saved: ${progressDate}`;
      progressStepEl.textContent = `Step: ${currentStepName}`;
      progressTravellersEl.textContent = `Travellers: 0`;
    }
    savedProgressCard.classList.remove("hidden");
    // Display travellers in sidebar
  //  Display travellers in sidebar AFTER card is shown
    if (travellersCount > 0) {
      // Small delay to ensure DOM is ready
      setTimeout(() => {
        displaySidebarTravellers();
      }, 50);
    }

    // Show/hide buttons based on travellers
    // const btnProceedPayment = document.getElementById("btnProceedPayment");
    // if (btnProceedPayment) btnProceedPayment.style.display = "block";
    
    const btnResume = document.getElementById("btnResume");
    if (travellersCount > 0) {
      if (btnResume) btnResume.style.display = "none";
    } else {
      if (btnResume) btnResume.style.display = "block";
    }
  }

  // Add event listeners for the buttons
  const btnResume = document.getElementById("btnResume");
  const btnStartFresh = document.getElementById("btnStartFresh");

  if (btnResume) {
    btnResume.removeEventListener("click", resumeHandler); // Remove old listener
    btnResume.addEventListener("click", resumeHandler);
  }
  
  if (btnStartFresh) {
    btnStartFresh.removeEventListener("click", startFreshHandler); // Remove old listener
    btnStartFresh.addEventListener("click", startFreshHandler);
  }

}
// Event handlers to prevent duplicate listeners
function resumeHandler() {
  const savedProgressCard = document.getElementById("savedProgressCard");
  savedProgressCard.classList.add("hidden");
  const savedProgress = loadProgress();
  if (savedProgress) {
    restoreProgress(savedProgress);
  }
}

function startFreshHandler() {
  const savedProgressCard = document.getElementById("savedProgressCard");
  savedProgressCard.classList.add("hidden");
  clearSavedProgress();
  clearFormData();
  travellers = [];
  userLoggedIn = false;
  showStep(1);
  update();
}

function showStep(step) {
  // Save progress before changing steps
    update();
  if (currentStep >= 2 && currentStep <= 5) {
    saveProgress();
  }
  // Hide all form sections
  document.querySelectorAll(".form-section").forEach((sec) => {
    sec.classList.add("hidden");
    if (Number(sec.dataset.step) === step) {
    
      sec.classList.remove("hidden");
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  });

  // Update sidebar active state
  document.querySelectorAll(".sidebar-item").forEach((item) => {
    item.classList.remove("active");
    item.classList.add("inactive");
    if (Number(item.dataset.step) === step) {
      item.classList.add("active");
      item.classList.remove("inactive");
    }
  });

  currentStep = step;

  // Update review content if on step 5
  if (step === 5) {
    updateReviewContent();
    // Update button text in edit mode
    if (window.isEditMode) {
      const proceedBtn = document.querySelector('[onclick="proceedToPayment()"]');
      if (proceedBtn) {
        proceedBtn.textContent = "Update Traveller";
        console.log("Changed button text to Update Traveller");
      }
    }
  }

  if (step === 1){
    // hide plan headers from previous page
    $('.plan-feature-purpose').addClass("hdn-display");
    $('.plan-feature-days').addClass("hdn-display");
  }

  if (step === 2){
    // hide plan headers from previous page
    $('.plan-price').addClass("hdn-display");
    $('.plan-feature-days').addClass("hdn-display");

    $('.plan-feature-purpose').removeClass("hdn-display");
    $('.plan-feature-purpose .plan-feature-text').html( selectedData['purpose']+" Visa" );
    $('.plan-feature-days').removeClass("hdn-display");
    $('.plan-feature-days .plan-feature-text').html( selectedData['travelDays']+" Days" );
    $('.visa-card-purpose').html(selectedData['purpose'])
  }
  if (step === 3){
    $('.plan-price').removeClass("hdn-display");
    $('.plan-price').html( selectedData['price'] );
    $('.plan-feature-purpose .plan-feature-text').html( selectedData['purpose']+" "+selectedData['visaType'] );
    $('.plan-feature-days').removeClass("hdn-display");
    $('.plan-feature-days .plan-feature-text').html( selectedData['stayPeriod'] +" Days "+ selectedData['entry-type'] + " Entry" );
  }
}

function validateField(fieldId, validationFn, errorMessage) {
  const field = document.getElementById(fieldId);
  const errorDiv = document.getElementById(fieldId + "Error");

  if (!field) return true;

  const isValid = validationFn(field.value);

  if (!isValid) {
    field.classList.add("error");
    if (errorDiv) errorDiv.textContent = errorMessage;
    return false;
  } else {
    field.classList.remove("error");
    if (errorDiv) errorDiv.textContent = "";
    return true;
  }
}


function validateMobile(value) {
  const mobileRegex = /^[6-9][0-9]{9}$/; 
  return mobileRegex.test(value.replace(/\s+/g, ""));
}


function validateEmail(value) {
  const emailRegex =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
  return emailRegex.test(value.trim());
}

// function validatePassportExpiry(value) {
//   if (!value) return false;
//   const expiryDate = new Date(value);
//   const today = new Date();
//   // Check if date is valid
//   if (isNaN(expiryDate.getTime())) return false;
//   // Passport should be valid for at least 6 months from today
//   const sixMonthsFromNow = new Date();
//   sixMonthsFromNow.setMonth(sixMonthsFromNow.getMonth() + 6);
//   return expiryDate > today;
// }

//Validate new PassportExpiry Function
function validatePassportExpiry(value) {
  if (!value) return false;

  // Try to parse the date
  const expiryDate = new Date(value);
  // Check if it's a valid date
  if (isNaN(expiryDate.getTime())) {
    return false;
  }

  // Normalize dates to ignore time of day
  expiryDate.setHours(0, 0, 0, 0);
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  // Compute six months from now more reliably
  const sixMonthsFromNow = new Date(today);

  // Helper: add months safely, handling end-of-month
  function addMonths(date, months) {
    const d = date.getDate();
    date.setMonth(date.getMonth() + months);
    if (date.getDate() < d) {
      date.setDate(0);
    }
    return date;
  }

  addMonths(sixMonthsFromNow, 6);

  return expiryDate > sixMonthsFromNow;
}

// START DATE MIN = Tomorrow
const today = new Date();
today.setDate(today.getDate() + 1);
const startMin = today.toISOString().split("T")[0];

document.getElementById("travelStartDate").setAttribute("min", startMin);

document.getElementById("travelStartDate").addEventListener("change", function () {
    const startDate = new Date(this.value);
    if (!this.value || isNaN(startDate.getTime())) return;
    startDate.setDate(startDate.getDate() + 1);
    const endMin = startDate.toISOString().split("T")[0];
    document.getElementById("travelEndDate").setAttribute("min", endMin);
});



function validateTravelStartDate(value) {
  if (!value) return false;
  const startDate = new Date(value);
  const today = new Date();
    // Check if date is valid
  if (isNaN(startDate.getTime())) return false;
  
  // Set today's time to start of day for comparison
  today.setHours(0, 0, 0, 0);
  startDate.setHours(0, 0, 0, 0);
  
  // Calculate minimum allowed date based on additionalDays
  const minAllowedDate = new Date(today);
  minAllowedDate.setDate(minAllowedDate.getDate() + additionalDays);
  
  // Travel date should not be more than 1 year in advance
  const oneYearFromNow = new Date(today);
  oneYearFromNow.setFullYear(oneYearFromNow.getFullYear() + 1);

  return startDate >= minAllowedDate && startDate <= oneYearFromNow;
}

function validateTravelEndDate(value) {
  if (!value) return false;
  const endDate = new Date(value);
  const today = new Date();
  const startDateValue = document.getElementById("travelStartDate")?.value;
  
  // Check if date is valid
  if (isNaN(endDate.getTime())) return false;
  
  // Set time to start of day for comparison
  today.setHours(0, 0, 0, 0);
  endDate.setHours(0, 0, 0, 0);
  
  // Calculate minimum allowed date based on additionalDays
  const minAllowedDate = new Date(today);
  minAllowedDate.setDate(minAllowedDate.getDate() + additionalDays);
  
  // End date must be in the future (respecting additionalDays)
  if (endDate < minAllowedDate) return false;
  
  if (!startDateValue) return true; 
  
  const startDate = new Date(startDateValue);
  if (isNaN(startDate.getTime())) return true;
  
  startDate.setHours(0, 0, 0, 0);
  
  // End date must be after start date
  if (endDate <= startDate) return false;
  
  // End date should not be more than 60 days from start date (visa validity)
  const maxEndDate = new Date(startDate);
  maxEndDate.setDate(maxEndDate.getDate() + 60);
  
  return endDate <= maxEndDate;
}

function updateTravelDays() {
  const start = document.getElementById("travelStartDate")?.value;
  const end   = document.getElementById("travelEndDate")?.value;
  //  console.log(`Start Date-> ${start}  End Date-> ${endDate}`);
  if (!validateTravelStartDate(start) || !validateTravelEndDate(end)) {
    selectedData['travelDays'] = null; 
    return;
  }

  const diffDays = getDateDifferenceInDays(start, end);
  console.log("Diff",diffDays);
  console.log("Difference Days",diffDays);
  if (diffDays === null) return;
  //  selectedData['travelDays'] = diffDays <= 30 ? 30 : 60;
  selectedData['travelDays'] = diffDays;
}

function getDateDifferenceInDays(start, end) {
  if (!start || !end) return null;
  
  const startDate = new Date(start);
  const endDate = new Date(end);

  if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) return null;

  const utcStart = Date.UTC(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
  const utcEnd   = Date.UTC(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());

  const diffMs = utcEnd - utcStart;
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  console.log("Difference in date",diffDays);
  return diffDays;
}




function validateDateOfBirth(value) {
  if (!value) return false;
  const dobDate = new Date(value);
  const today = new Date();
  // Check if date is valid
  if (isNaN(dobDate.getTime())) return false;

  // Check if date is not in future
  if (dobDate > today) return false;
  let age = today.getFullYear() - dobDate.getFullYear();
  const monthDiff = today.getMonth() - dobDate.getMonth();

  if (
    monthDiff < 0 ||
    (monthDiff === 0 && today.getDate() < dobDate.getDate())
  ) {
    age--;
  }

  return age >= 0 && age <= 100;
}

function validatePassportNumber(value) {
  // Basic passport number validation (alphanumeric, 6-10 characters)
  const passportRegex = /^[A-Z0-9]{6,10}$/;
  return passportRegex.test(value.toUpperCase().replace(/\s+/g, ""));
}

function validateName(value) {
  // Name should contain only letters, spaces, hyphens, and apostrophes
  const nameRegex = /^[a-zA-Z\s\-.']{2,50}$/;
  return nameRegex.test(value.trim());
}

function validateStep1() {
  $('.error-card').removeClass('error-card');
  let allValid = true;

  const continueBtn = document.getElementById('step1ContinueBtn');
  const radiosVisit = document.querySelectorAll('input[name="visit-purpose"]');
  // const radiosDays = document.querySelectorAll('input[name="numberofdays"]');

  // const visitSelected = Array.from(radiosVisit).some(r => r.checked);
  // const daysSelected = Array.from(radiosDays).some(r => r.checked);

  // if (!visitSelected){
  //   alert("Please select Purpose of Visit");
  //   $('#purposeOfVisitSection .card').addClass('error-card');
  //   document.querySelector('#purposeOfVisitSection .card-container').scrollIntoView({ behavior: 'smooth' });
  // }
  //  if (!daysSelected){
  //   alert("Please select Number of Days You want to Stay");
  //   $('#purposeOfVisitSection .num-day').addClass('error-card');
  //   document.querySelector('#purposeOfVisitSection .days-container').scrollIntoView({ behavior: 'smooth' });

  // }
  // allValid = ( daysSelected)
  // allValid = (visitSelected && daysSelected)
  // selectedData['purpose'] = $('input[name="visit-purpose"]:checked').val();
  // selectedData['purpose'] = $('input[name="visit-purpose"]:checked').val();
  // selectedData['travelDays'] = $('input[name="numberofdays"]:checked').val();

      // Travel dates validation
    allValid &= validateField(
      "travelStartDate",
       validateTravelStartDate,
      `Travel start date must be at least ${additionalDays} day(s) from today`
      );
    allValid &= validateField(
      "travelEndDate",
       validateTravelEndDate,
     `Travel end date must be after start date and at least ${additionalDays} day(s) from today`
     );
     if(allValid){
       updateTravelDays();
     }else{
      alert("Please Enter Travel Dates");
      return;
     }
  // preselect adult as the price option
  document.querySelectorAll('.visa-card').forEach(card => {
    const groupKey = card.dataset.group;
    const priceOptions = card.querySelectorAll('.dropdown-content p');

    if (!priceOptions.length) return;

    // Try to find 'Adult' option
    let adultOption = Array.from(priceOptions).find(p => p.textContent.trim().startsWith("Adult"));

    // If 'Adult' not found, select the first one
    let defaultOption = adultOption || priceOptions[0];

    if (defaultOption) {
      // Extract data from the onclick call in a safe way
      const onclickValue = defaultOption.getAttribute('onclick');
      const args = onclickValue.match(/'([^']*)'/g)?.map(a => a.replace(/'/g, ''));

      if (args && args.length >= 4) {
        const [value, variantId, group, ageGroup] = args;
        let visaFee = visaVariantData[variantId]['visaFee']
        let govtFee = visaVariantData[variantId]['govtFee']
        let serviceTax = visaVariantData[variantId]['serviceTax']
        let matrixGovtFee = visaVariantData[variantId]['matrixGovtFee']
        let matrixFee = visaVariantData[variantId]['matrixFee']
        selectPrice(value, variantId, group, ageGroup, visaFee, govtFee, serviceTax, matrixGovtFee, matrixFee);
      }
    }
  });
  if (allValid){
    if (!currentUser){
      showAuthModal("signup");
      localStorage.setItem("visaStartDate", $('#travelStartDate').val());
      localStorage.setItem("visaEndDate", $('#travelEndDate').val());
      return;
    }
  }
  return allValid;
}


function validateStep3() {
  $('.error-visa-card').removeClass('error-visa-card');
  let allValid = false;
  if ($('.visa-card-active:visible').length > 0) {
    allValid = true;
  }
  else{
    alert("Please select a type of VISA");
    $('.visa-card').addClass('error-visa-card');
    document.querySelector('#visaTypeSection .visa-card').scrollIntoView({ behavior: 'smooth' });
  }

  if (allValid){
    const $activeCard = $('.visa-card-active');
    selectedData['visaValidity'] = $activeCard.data('validity');
    selectedData['price']        = $activeCard.data('selectedPrice');
    selectedData['entryType']    = $activeCard.data('entryType');
    selectedData['ageGroup']     = $activeCard.data('ageGroup');
    selectedData['stayPeriod']   = $activeCard.data('stayPeriod');
    selectedData['variantId']    = $activeCard.data('selectedVariant');
    selectedData['processingType'] = $activeCard.data('processingType');
    selectedData['deliveryType'] = $activeCard.data('deliveryType');
    selectedData['visaFee'] = $activeCard.data('visaFee');
    selectedData['govtFee'] = $activeCard.data('govtFee');
    selectedData['serviceTax'] = $activeCard.data('serviceTax');
    selectedData['matrixGovtFee'] = $activeCard.data('matrixGovtFee');
    selectedData['matrixFee'] = $activeCard.data('matrixFee');
  }
  return allValid;
}

function validateStep2() {
  let allValid = true;

  // Basic required field validation
  allValid &= validateField(
    "title",
    (v) => validateName(v),
    "Please select a valid Title"
  );
   
  allValid &= validateField(
    "firstName",
    (v) => validateName(v),
    "First name is required & contain only letters"
  );
  allValid &= validateField(
    "lastName",
    (v) => validateName(v),
    "Last name is required & contain only letters"
  );
  const middleName = document.getElementById("middleName")?.value;
  if (middleName && middleName.trim().length > 0) {
    allValid &= validateField(
      "middleName",
      (v) => validateName(v),
      "Middle name should contain only letters"
    );
  }
  allValid &= validateField(
    "gender",
    (v) => v.trim().length > 0,
    "Please select gender"
  );
  allValid &= validateField(
    "occupation",
    (v) => v.trim().length > 0,
    "Please select occupation"
  );
  allValid &= validateField(
    "passportNumber",
    (v) => validatePassportNumber(v),
    "Passport number is required"
  );

  // Specific validations
  allValid &= validateField(
    "mobile",
    validateMobile,
    "Please enter a valid 10-digit mobile number"
  );
  allValid &= validateField(
    "email",
    validateEmail,
    "Please enter a valid email address"
  );
  allValid &= validateField(
    "dob",
    validateDateOfBirth,
    "Please enter a valid date of birth (age must be 18-100)"
  );
  allValid &= validateField(
    "passportExpiry",
    validatePassportExpiry,
    "Passport Validity should be minimum 6 months"
  );

  // Check passport upload requirement
  // const skipPassportChecked =
  //   document.getElementById("skipPassportUpload").checked;

  if (true) {
    // If not skipped, all uploads are mandatory
    const frontUploaded = document
      .getElementById("passportFrontUpload")
      .classList.contains("uploaded");
    const backUploaded = document
      .getElementById("passportBackUpload")
      .classList.contains("uploaded");
    const photoUploaded = document
      .getElementById("travelerPhotoUpload")
      .classList.contains("uploaded");

    if (!frontUploaded || !backUploaded || !photoUploaded) {
      alert("Please upload both passport front and back pages.");
      allValid = false;
    }

  }
  return allValid;
}

function validateStep4() {
  let allValid = true;

  // Travel dates validation
  allValid &= validateField(
    "travelStartDate",
    validateTravelStartDate,
    `Travel start date must be at least ${additionalDays} day(s) from today`
  );
  allValid &= validateField(
    "travelEndDate",
    validateTravelEndDate,
    `Travel end date must be after start date and at least ${additionalDays} day(s) from today`
  );

  // Required file validation
  const flightFile = document.getElementById("flightFile");
  if (!flightFile.files.length) {
    const errorDiv = document.getElementById("flightFileError");
    if (errorDiv) errorDiv.textContent = "Flight ticket is required";
    flightFile.classList.add("error");
    allValid = false;
  } else {
    // Validate file type and size
    const file = flightFile.files[0];
    const allowedTypes = [
      "application/pdf",
      "image/jpeg",
      "image/jpg",
      "image/png",
    ];
    const maxSize = 7 * 1024 * 1024; // 10MB

    if (!allowedTypes.includes(file.type)) {
      const errorDiv = document.getElementById("flightFileError");
      if (errorDiv)
        errorDiv.textContent = "Flight ticket must be PDF format";
      flightFile.classList.add("error");
      allValid = false;
    } else if (file.size > maxSize) {
      const errorDiv = document.getElementById("flightFileError");
      if (errorDiv)
        errorDiv.textContent = "Flight ticket file size must be less than 7MB";
      flightFile.classList.add("error");
      allValid = false;
    } else {
      const errorDiv = document.getElementById("flightFileError");
      if (errorDiv) errorDiv.textContent = "";
      flightFile.classList.remove("error");
    }
  }

  return allValid;
}

////////////////// Flight File upload changes ///////////////////
const flightInput = document.getElementById("flightFile");
const flightLabel = document.querySelector("label[for='flightFile']");
const flightPreviewImg = document.getElementById("flightPreview");
const flightError = document.getElementById("flightFileError");

// Save original state
const originalPreview = flightPreviewImg.src;
const originalText = flightLabel.querySelector(".upload-text").textContent;
const originalSubtitle = flightLabel.querySelector(".upload-subtitle").textContent;

// SVG icon
const PDF_ICON_SVG =
  "data:image/svg+xml;base64," +
  "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KPHBhdGggZmlsbD0iI2RjMjYyNiIgZD0iTTYgMmg3bDUgNXYxNWEyIDIgMCAwIDEtMiAyaC0xMGEyIDIgMCAwIDEtMi0yVjRhMiAyIDAgMCAxIDItMnoiLz4KPHBhdGggZmlsbD0iI2ZmZiIgZD0iTTE0IDJ2Nmg2Ii8+Cjx0ZXh0IHg9IjYiIHk9IjE4IiBmaWxsPSIjZmZmIiBmb250LXNpemU9IjgiIGZvbnQtZmFtaWx5PSJBcmlhbCIgZm9udC13ZWlnaHQ9ImJvbGQiPlBERjwvdGV4dD4KPC9zdmc+";

flightInput.addEventListener("change", () => {
  const file = flightInput.files[0];

  // Reset
  if (!file) {
    resetFlightUpload();
    return;
  }

  // Validate PDF
  if (file.type !== "application/pdf") {
    flightError.textContent = "Only PDF files are allowed";
    resetFlightUpload();
    return;
  }

  // Uploaded state
  flightError.textContent = "";

  flightPreviewImg.src = PDF_ICON_SVG;
  flightLabel.querySelector(".upload-text").textContent = "Uploaded";
  flightLabel.querySelector(".upload-subtitle").textContent = truncateFileName(file.name);
  flightLabel.classList.add("uploaded");
});

function resetFlightUpload() {
  flightInput.value = "";
  flightError.textContent = "";

  flightPreviewImg.src = originalPreview;
  flightLabel.querySelector(".upload-text").textContent = originalText;
  flightLabel.querySelector(".upload-subtitle").textContent = originalSubtitle;
  flightLabel.classList.remove("uploaded");
}

function truncateFileName(name, max = 28) {
  return name.length > max ? name.slice(0, max) + "…" : name;
}
////////////////////////////////////////////////////////////////////////////////

///////////////////////// Hotel file upload changes //////////////////////////////

const hotelInput = document.getElementById("hotelFile");
const hotelLabel = document.querySelector("label[for='hotelFile']");
const hotelPreviewImg = document.getElementById("hotelPreview");

// Save original state
const hotelOriginalPreview = hotelPreviewImg.src;
const hotelOriginalText = hotelLabel.querySelector(".upload-text").textContent;
const hotelOriginalSubtitle = hotelLabel.querySelector(".upload-subtitle").textContent;

hotelInput.addEventListener("change", () => {
  const file = hotelInput.files[0];

  // Reset
  if (!file) {
    resetHotelUpload();
    return;
  }

  // Validate PDF
  if (file.type !== "application/pdf") {
    alert("Only PDF files are allowed");
    resetHotelUpload();
    return;
  }

  // Uploaded state
  hotelPreviewImg.src = PDF_ICON_SVG;
  hotelLabel.querySelector(".upload-text").textContent = "Uploaded";
  hotelLabel.querySelector(".upload-subtitle").textContent = truncateFileName(file.name);
  hotelLabel.classList.add("uploaded");
});

function resetHotelUpload() {
  hotelInput.value = "";
  hotelPreviewImg.src = hotelOriginalPreview;
  hotelLabel.querySelector(".upload-text").textContent = hotelOriginalText;
  hotelLabel.querySelector(".upload-subtitle").textContent = hotelOriginalSubtitle;
  hotelLabel.classList.remove("uploaded");
}
////////////////////////////////////////////////////////////////////////////////////////

///////////FILE PREVIEW/////////////////// RISHABH ////////////////////
document.querySelectorAll('.photo-upload input[type="file"]').forEach(input => {
  input.addEventListener('change', event => {
    const file = event.target.files[0];
    const container = event.target.closest('.photo-upload');
    const img = container.querySelector('img');
    const errorDiv = container.querySelector('.error-message');

    if (file) {
      const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
      const maxSize = 7 * 1024 * 1024; // 10MB

      // Validate before preview
      // if (!allowedTypes.includes(file.type)) {
      //   if (errorDiv) errorDiv.textContent = "Only JPG or PNG images are allowed";
      //   if (img) img.src = "error-icon.png"; // optional fallback
      //   return;
      // } 
      if (file.size > maxSize) {
        if (errorDiv) errorDiv.textContent = "File must be less than 7MB";
        if (img) img.src = "error-icon.png";
        return;
      }

      // Clear any old error
      if (errorDiv) errorDiv.textContent = "";

      // Show image preview
      if (file.type.startsWith("image/")) {
        const reader = new FileReader();
        reader.onload = e => {
          if (img) img.src = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    }
  });
});


// mobile step viewer or counter
        const progress = document.getElementById('progress');
        const circles = document.querySelectorAll('.circle');
        function update() {
            // 1. Update the 'active' class on the circles (Green color)
            circles.forEach((circle, idx) => {
                if (idx < currentStep) {
                    circle.classList.add('active'); 
                } else {
                    circle.classList.remove('active'); 
                }
            });
            const progressPercent = ((currentStep - 1) / 4) * 100;
            progress.style.width = progressPercent + '%';
          }
            


///////////////////////////////////////////////////////
// function updateReviewContent() {
//   const firstName = document.getElementById("firstName").value || "";
//   const lastName = document.getElementById("lastName").value || "";
//   const email = document.getElementById("email").value || "";
//   const mobile = document.getElementById("mobile").value || "";

//   const travelStartDateElement = document.getElementById("travelStartDate");
//   const travelEndDateElement = document.getElementById("travelEndDate");

//   const travelStartDate = travelStartDateElement
//     ? travelStartDateElement.value
//     : "";
//   const travelEndDate = travelEndDateElement ? travelEndDateElement.value : "";

//   const reviewContent = document.getElementById("reviewContent");
//   if (reviewContent) {
//     reviewContent.innerHTML = `
//       <div style="margin-bottom: 1rem;">
//         <strong>Name:</strong> ${firstName} ${lastName}
//       </div>
//       <div style="margin-bottom: 1rem;">
//         <strong>Email:</strong> ${email}
//       </div>
//       <div style="margin-bottom: 1rem;">
//         <strong>Mobile:</strong> ${mobile}
//       </div>
//       <div style="margin-bottom: 1rem;">
//         <strong>Travel Dates:</strong> ${
//           travelStartDate
//             ? new Date(travelStartDate).toLocaleDateString()
//             : "Not specified"
//         } to ${
//       travelEndDate
//         ? new Date(travelEndDate).toLocaleDateString()
//         : "Not specified"
//     }
//       </div>
//       <div style="margin-bottom: 1rem;">
//         <strong>Documents:</strong> ${getUploadedDocuments()}
//       </div>
//     `;
//   }
// }

function updateReviewContent() {
  const title = document.getElementById("title").value || "";
  const firstName = document.getElementById("firstName").value || "";
  const lastName = document.getElementById("lastName").value || "";
  const email = document.getElementById("email").value || "";
  const mobile = document.getElementById("mobile").value || "";

  const travelStartDateElement = document.getElementById("travelStartDate");
  const travelEndDateElement = document.getElementById("travelEndDate");

  const travelStartDate = travelStartDateElement ? travelStartDateElement.value : "";
  const travelEndDate = travelEndDateElement ? travelEndDateElement.value : "";

  const reviewContent = document.getElementById("reviewContent");
  if (reviewContent) {
    reviewContent.innerHTML = `
      <div style="margin-bottom: 1rem;"><strong>Name:</strong> ${title}. ${firstName} ${lastName}</div>
      <div style="margin-bottom: 1rem;"><strong>Email:</strong> ${email}</div>
      <div style="margin-bottom: 1rem;"><strong>Mobile:</strong> ${mobile}</div>
      <div style="margin-bottom: 1rem;">
        <strong>Travel Dates:</strong>
        ${
          travelStartDate
            ? new Date(travelStartDate).toLocaleDateString()
            : "Not specified"
        } to ${
      travelEndDate
        ? new Date(travelEndDate).toLocaleDateString()
        : "Not specified"
    }
      </div>
      <div style="margin-bottom: 1rem;">
        <strong>Documents:</strong> Passport (Front & Back), Traveler Photo, Flight Ticket, Hotel Booking, Bank Statement
      </div>
      ${getUploadedDocuments()}
    `;
  }
}


function getUploadedDocuments() {
  const docs = [];

  const passportFront = document.getElementById("passportFrontUpload");
  const passportBack = document.getElementById("passportBackUpload");
  const travelerPhoto = document.getElementById("travelerPhotoUpload");

  const flightFile = document.getElementById("flightFile");
  const hotelFile = document.getElementById("hotelFile");
  // const bankFile = document.getElementById("bankFile");

  const uploadedDocs = [
    {
      name: "Passport",
      uploaded: passportFront?.classList.contains("uploaded") && passportBack?.classList.contains("uploaded"),
     placeholder:window.assetUrl.passport
    },
    {
      name: "Traveler Photo",
      uploaded: travelerPhoto?.classList.contains("uploaded"),
       placeholder:window.assetUrl.profile
    },
    {
      name: "Flight Ticket",
      uploaded: flightFile && flightFile.files.length > 0,
     placeholder:window.assetUrl.flight
    },
    {
      name: "Hotel Booking",
      uploaded: hotelFile && hotelFile.files.length > 0,
      placeholder:window.assetUrl.hotel
    
    },
    // {
    //   name: "Bank Statement",
    //   uploaded: bankFile && bankFile.files.length > 0,
    //   placeholder:window.assetUrl.bankStatement
    // }
  ];

  //  build HTML layout
  let html = `<div class="document-preview" style="display:flex;flex-wrap:wrap;gap:10px;margin-top:15px; justify-content:center">`;

  uploadedDocs.forEach(doc => {
    const iconSrc=doc.uploaded ? window.assetUrl.tick : window.assetUrl.cross;
    
    html += `
   <div style="width:85px;text-align:center;position:relative;font-family:'Inter',sans-serif;">
  <div style="position:relative;">
    <img src="${doc.placeholder}" alt="${doc.name}"
      style="width:100%;height:70px;object-fit:cover;border-radius:8px;mix-blend-mode:multiply;
             background-color:#fff; box-shadow:0 1px 3px rgba(0,0,0,0.08);">
    <div style="position:absolute;bottom:4px;right:2px;
                border-radius:50%;width:14px;height:14px;display:flex;
                align-items:center;justify-content:center;
                box-shadow:0 1px 3px rgba(0,0,0,0.15);">
      <img src=${iconSrc} style="width:14px;height:14px;" />
    </div>
  </div>
  <div style="margin-top:6px;font-size:12px;font-weight:500;color:#333;
              white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">
    ${doc.name}
  </div>
</div> `;
  });

  html += `</div>`;
  return html;
}


// function getUploadedDocuments() {
//   const docs = [];

//   // Check passport uploads
//   const skipPassportElement = document.getElementById("skipPassportUpload");
//   const passportFrontElement = document.getElementById("passportFrontUpload");
//   const passportBackElement = document.getElementById("passportBackUpload");

//   if (skipPassportElement && passportFrontElement && passportBackElement) {
//     // const skipPassport = skipPassportElement.checked;
//     // if (!skipPassport) {
//       const frontUploaded = passportFrontElement.classList.contains("uploaded");
//       const backUploaded = passportBackElement.classList.contains("uploaded");
//       if (frontUploaded && backUploaded) {
//         docs.push("Passport (Front & Back)");
//       } else if (frontUploaded) {
//         docs.push("Passport (Front Only)");
//       } else if (backUploaded) {
//         docs.push("Passport (Back Only)");
//       }
//     // } else {
//     //   docs.push("Passport (Skipped)");
//     // }
//   }

//   // Check traveler photo
//   const travelerPhotoUploaded = document.getElementById("travelerPhotoUpload").classList.contains("uploaded");
//   if (travelerPhotoUploaded) {
//     docs.push("Traveler Photo");
//   }

//   // Check other document uploads
//   const flightFile = document.getElementById("flightFile");
//   const hotelFile = document.getElementById("hotelFile");
//   const bankFile = document.getElementById("bankFile");

//   if (flightFile && flightFile.files.length > 0) docs.push("Flight Ticket");
//   if (hotelFile && hotelFile.files.length > 0) docs.push("Hotel Booking");
//   if (bankFile && bankFile.files.length > 0) docs.push("Bank Statement");

//    return docs.length > 0 ? docs.join(", ") : "None uploaded";
// }

// Passport skip checkbox functionality
// document.addEventListener("DOMContentLoaded", function () {
//   const skipCheckbox = document.getElementById("skipPassportUpload");
//   const personalDetailsSection = document.getElementById(
//     "personalDetailsSection"
//   );
//   if (skipCheckbox) {
//     skipCheckbox.addEventListener("change", function () {
//       const passportUploads = document.getElementById("passportUploads");
//       const passportFrontUpload = document.getElementById(
//         "passportFrontUpload"
//       );
//       const passportBackUpload = document.getElementById("passportBackUpload");
//       const travelerPhotoUpload = document.getElementById(
//         "travelerPhotoUpload"
//       );

//       if (this.checked) {
//         passportUploads.classList.add("disabled");
//         // Disable traveler photo upload
//         travelerPhotoUpload.classList.add("disabled");
//         travelerPhotoUpload.style.opacity = "0.5";
//         travelerPhotoUpload.style.pointerEvents = "none";
//         // Reset upload states
//         resetPassportUpload(
//           passportFrontUpload,
//           "Upload Passport Front",
//           "Upload the front page of your passport"
//         );
//         resetPassportUpload(
//           passportBackUpload,
//           "Upload Passport Back",
//           "Upload the back page of your passport"
//         );
//         // Show personal details section when checkbox is checked
//         if (personalDetailsSection) {
//           personalDetailsSection.style.display = "block";

//           // Show all form fields immediately when skip is checked
//           const formGrids =
//             personalDetailsSection.querySelectorAll(".form-grid");
//           const headings = personalDetailsSection.querySelectorAll("h3");
//           formGrids.forEach((grid) => (grid.style.display = "grid"));
//           headings.forEach((heading) => (heading.style.display = "block"));
//         }
//       } else {
//         passportUploads.classList.remove("disabled");
//         // Enable traveler photo upload
//         travelerPhotoUpload.classList.remove("disabled");
//         travelerPhotoUpload.style.opacity = "1";
//         travelerPhotoUpload.style.pointerEvents = "auto";
//         // Hide personal details section if no uploads and checkbox unchecked
//         const frontUploaded =
//           passportFrontUpload.classList.contains("uploaded");
//         const backUploaded = passportBackUpload.classList.contains("uploaded");

//         if (!frontUploaded && !backUploaded && personalDetailsSection) {
//           personalDetailsSection.style.display = "none";
//         }
//       }
//     });
//   }
// });

// Canonical JSON String - sorts keys alphabetically and creates proper JSON format
function canonicalJSONString(fields) {
  // Sort the keys alphabetically
  const sortedKeys = Object.keys(fields).sort();
  let parts = [];

  sortedKeys.forEach((k) => {
    // Preserve spaces in values
    let value = fields[k] == null ? "" : fields[k].toString();
    // Escape quotes inside string values
    value = value.replace(/"/g, '\\"');
    parts.push(`"${k}":"${value}"`);
  });

  // combine all the keys as string without any space (except in values)
  return `{${parts.join(",")}}`;
}

// Function to set the data coming from url into blob and saving it in the upload files
async function setFileInputAndPreviewFromUrl(
  fileInputId,
  previewImgId,
  fileUrl,
  fileNamePrefix
) {
  if (!fileUrl) return;

  try {
    const res = await fetch(fileUrl);
    const blob = await res.blob();

    const ext = blob.type.split("/")[1] || "jpg";
    const file = new File([blob], `${fileNamePrefix}.${ext}`, {
      type: blob.type,
    });

    // Set file input
    const dt = new DataTransfer();
    dt.items.add(file);
    const input = document.getElementById(fileInputId);
    if (input) {
      input.files = dt.files;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    }

    // Set preview image
    const preview = document.getElementById(previewImgId);
    if (preview) {
      preview.src = URL.createObjectURL(file);
      preview.classList.add("has-image");
    }

  } catch (err) {
    console.error("Failed to load file preview:", fileUrl, err);
  }
}

// Convert the saved based64 to file input type
function base64ToFile(base64, fileName) {
  let mime = "";
  let data = base64;

  // If base64 is a data URL
  if (base64.startsWith("data:")) {
    const parts = base64.split(",");
    mime = parts[0].match(/:(.*?);/)[1];
    data = parts[1];
  } else {
    // RAW base64 — try to infer type
    if (base64.startsWith("iVBOR")) {
      mime = "image/png";
    } else if (base64.startsWith("/9j/")) {
      mime = "image/jpeg";
    } else if (base64.startsWith("UklGR")) {
      mime = "image/webp";
    } else {
      mime = "image/png"; // safest default (keeps alpha)
    }
  }

  const byteString = atob(data);
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);

  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  return new File([ab], fileName, { type: mime });
}


// Set the file input from base64 data
function setFileInputFromBase64(
  fileInputId,
  previewImgId,
  base64,
  fileName
) {
  if (!base64) return;

  const file = base64ToFile(base64, fileName);

  // Set file input
  const dt = new DataTransfer();
  dt.items.add(file);

  const input = document.getElementById(fileInputId);
  if (input) {
    input.files = dt.files;
    input.dispatchEvent(new Event("change", { bubbles: true }));
  }

  // Preview (use base64 directly — safest)
  const preview = document.getElementById(previewImgId);
  if (preview) {
    preview.src = base64.startsWith("data:")
      ? base64
      : `data:${file.type};base64,${base64}`;
    preview.classList.add("has-image");
  }
}



function retryUpload(){
  window.passportDataFetched=false;
  // Reset upload UI states
  resetPassportUpload(
    document.getElementById("passportFrontUpload"),
    "Upload Passport Front",
    "Upload the front page of your passport"
  );
  resetPassportUpload(
    document.getElementById("passportBackUpload"),
    "Upload Passport Back",
    "Upload the back page of your passport"
  );
  resetPassportUpload(
    document.getElementById("travelerPhotoUpload"),
    "Upload Photo",
    "Passport size photo (optional)"
  );
      document.querySelectorAll(".photo-preview img").forEach(img => {
      if (img.src.startsWith("blob:") || img.src.startsWith("data:")) {
      img.src = img.dataset.placeholder;
    }
    });

  document.querySelectorAll('.photo-upload input[type="file"]').forEach(input => {
  input.value = "";  
});

}

// Function to fetch passport data using real API
async function fetchPassportDataFromAPI() {
  // Check if API has already been called
  if (window.passportDataFetched) {
    return;
  }

  console.log("Triggering API to fetch passport data...");
  window.passportDataFetched = true;

  const personalDetailsSection = document.getElementById(
    "personalDetailsSection"
  );

  if (personalDetailsSection) {
    // Hide all form content initially
    const formGrids = personalDetailsSection.querySelectorAll(".form-grid");
    const headings = personalDetailsSection.querySelectorAll("h3");
    formGrids.forEach((grid) => (grid.style.display = "none"));
    headings.forEach((heading) => (heading.style.display = "none"));

    const loadingDiv = document.createElement("div");
    loadingDiv.id = "apiLoadingIndicator";
    loadingDiv.style.cssText =
      "background: #eff6ff; border: 1px solid #3b82f6; color: #1e40af; padding: 1rem; border-radius: 8px; margin-bottom: 1rem; text-align: center;";
    loadingDiv.innerHTML =
      "<strong>Processing passport images...</strong><br><small>Extracting information from your documents</small>";
      personalDetailsSection.insertBefore(
      loadingDiv,
      personalDetailsSection.firstChild
    );
  }
  // Fetch text-only fields (empty object for this API)
  let textFields = {};

  // Fetch Stringified JSON, sorted and without spaces between keys
  const bodyText = canonicalJSONString(textFields);

  // Get Timestamp and Create HMAC encode string
  const timestamp = Math.floor(Date.now() / 1000);
  const apiEndPoint = API_CONFIG.API_ENDPOINT;
  const message = `POST|${apiEndPoint}|${timestamp}|${bodyText}`;

  console.log("Signing message:", message);

  // Compute HMAC using CryptoJS Library
  const hashData = CryptoJS.HmacSHA256(message, API_CONFIG.SECRET).toString(
    CryptoJS.enc.Hex
  );

  console.log("hash_data:", hashData);

  // Fetch Form Data and append the hash data as a parameter
  console.log(uploadedFiles, "uploaded files");
  let formData = new FormData();
  formData.append("passportFront", uploadedFiles.passportFront);
  formData.append("passportBack", uploadedFiles.passportBack);
  formData.append("travellerImage", uploadedFiles.travellerImage);
  formData.append("hash_data", hashData);

 
  // Send AJAX with headers (timestamp only in header, not body)
  $.ajax({
    url: `${API_CONFIG.API_URL}${apiEndPoint}?success=1`,
    type: "POST",
    headers: {
      "X-API-Key": API_CONFIG.API_KEY,
      "X-Auth-Token": timestamp,
    },
    data: formData,
    processData: false,
    contentType: false,
    xhrFields: { withCredentials: true },
    success: function (resp) {
      console.log("Success:", resp);
      // Remove loading indicator
      const loadingDiv = document.getElementById("apiLoadingIndicator");
      if (loadingDiv) {
        loadingDiv.remove();
      }
      // Prepopulate and mark as required based on API response
      const setFieldValue = (id, value,validator, message) => {
        const el = document.getElementById(id);
        if (el) {
          el.value = value;
          el.required = true; 
          // validateField(id,validator,message,);
            if (typeof validator === "function") {
            validateField(id, validator, message);
              }
          el.dispatchEvent(new Event("input",{bubbles:true}));
          el.dispatchEvent(new Event("change",{bubbles:true}));
          el.classList.add("required-highlight"); // optional visual cue
        }
      };

      if (resp?.data?.passportNumber) {
        setFieldValue("passportNumber", resp.data.passportNumber,validatePassportNumber,"Passport number should be 6-10 alphanumeric characters");
      }

      if (resp?.data?.travellerFirstName) {
        setFieldValue("firstName", resp.data.travellerFirstName,validateName,"First name should contain only letters (2-50 characters)");
      }

      if (resp?.data?.travellerTitle) {
        setFieldValue("title", resp.data.travellerTitle,validateName,"Please select the title");
      }

      if (resp?.data?.travellerMiddleName) {
        setFieldValue("middleName", resp.data.travellerMiddleName);
      }

      if (resp?.data?.travellerLastName) {
        setFieldValue("lastName", resp.data.travellerLastName,validateName,"Last name should contain only letters (2-50 characters)");
      }

      if (resp?.data?.gender) {
          document.getElementById("gender").value =
          resp?.data?.gender.toLowerCase();
      }

      if (resp?.data?.travellerDob) {
        // Convert DD-MM-YYYY to YYYY-MM-DD
        const dobParts = resp?.data?.travellerDob.split("-");
        if (dobParts.length === 3) {
          const formattedDob = `${dobParts[2]}-${dobParts[1]}-${dobParts[0]}`;
          setFieldValue("dob",formattedDob,validateDateOfBirth,"Please enter a valid date of birth (age 18-100)")
          // document.getElementById("dob").value = formattedDob;
        }
      }

      if (resp?.data?.passportExpiry) {
        // Convert DD-MM-YYYY to YYYY-MM-DD
        const expiryParts = resp?.data?.passportExpiry.split("-");
        if (expiryParts.length === 3) {
          const formattedExpiry = `${expiryParts[2]}-${expiryParts[1]}-${expiryParts[0]}`;
          // document.getElementById("passportExpiry").value = formattedExpiry;
          setFieldValue("passportExpiry",formattedExpiry,validatePassportExpiry,"Passport Validity should be minimum 6 months")
        }
      }

      // Show success message
      const successDiv = document.createElement("div");
      successDiv.style.cssText =
        "background: #ecfdf5; border: 1px solid #10b981; color: #047857; padding: 1rem; border-radius: 8px; margin-bottom: 1rem; text-align: center;";
      successDiv.innerHTML =
        "<strong>Documents processed successfully!</strong><br><small>Please review and complete the form below</small>";
      personalDetailsSection.insertBefore(
        successDiv,
        personalDetailsSection.firstChild
      );
      // const validationPassed = validateStep3();

      // if (!validationPassed) {
      //   console.warn("Some required fields are missing or invalid.");
      // } else {
      //   console.log("All pre-filled fields validated successfully");
      // }
          // Show form fields
          const formGrids = personalDetailsSection.querySelectorAll(".form-grid");
          const headings = personalDetailsSection.querySelectorAll("h3");
          formGrids.forEach((grid) => (grid.style.display = "grid"));
          headings.forEach((heading) => (heading.style.display = "block"));
    
          // Remove success message after 5 seconds
          setTimeout(() => {
            successDiv.remove();
          }, 5000);
    },
    error: function (xhr) {
      console.error("Error:", xhr.responseText);

      // Remove loading indicator
      const loadingDiv = document.getElementById("apiLoadingIndicator");
      if (loadingDiv) {
        loadingDiv.remove();
      }

      // Show error message
      const errorDiv = document.createElement("div");
      const reUpload=document.createElement('button');
      errorDiv.style.cssText ="margin-top:20px;display:flex;flex-direction:column;align-items:center;background: #fee2e2; border: 1px solid #ef4444; color: #991b1b; padding: 1rem; border-radius: 8px; margin-bottom: 1rem; text-align: center;";
      errorDiv.innerHTML = `<strong>Error processing documents</strong><br><small>${ xhr.responseText || "Please try again" }</small>`;
      
      reUpload.textContent = "Retry Upload";
      reUpload.style.cssText = `
      margin-top: 12px;
      padding: 8px 16px;
      background: #ef4444;
      color: #fff;
      border: none;
      border-radius: 6px;
      cursor: pointer;
       `;
       reUpload.addEventListener("click", () => {
       errorDiv.remove(); 
       retryUpload();    
       });
      errorDiv.appendChild(reUpload);

      personalDetailsSection.insertBefore(
        errorDiv,
        personalDetailsSection.firstChild
      );

      // Show form fields for manual entry
      // const formGrids = personalDetailsSection.querySelectorAll(".form-grid");
      // const headings = personalDetailsSection.querySelectorAll("h3");
      // formGrids.forEach((grid) => (grid.style.display = "grid"));
      // headings.forEach((heading) => (heading.style.display = "block"));

      // Remove error message after 7 seconds
      // setTimeout(() => {
      //   errorDiv.remove();
      // }, 7000);
    },
  });
}
// Fetch saved travellers from API
async function fetchSavedTravellers() {
  if (!userLoggedIn || !currentUser?.email) {
    console.log("User not logged in, skipping fetch saved travellers");
    return;
  }

  console.log("Fetching saved travellers for:", currentUser);

  const textFields = {
    customerEmail: currentUser?.email,
  };

  // Get Timestamp and Create HMAC
  const bodyText = canonicalJSONString(textFields);
  const timestamp = Math.floor(Date.now() / 1000);
  const apiEndPoint = API_CONFIG.GET_TRAVELLER_LIST;
  const message = `POST|${apiEndPoint}|${timestamp}|${bodyText}`;

  console.log("Signing message:", message);

  const hashData = CryptoJS.HmacSHA256(message, API_CONFIG.SECRET).toString(
    CryptoJS.enc.Hex
  );

  console.log("hash_data:", hashData);
  let formData = new FormData();
  formData.append("customerEmail", currentUser?.email);
  formData.append("hash_data", hashData);

  $.ajax({
    url: `${API_CONFIG.API_URL}${apiEndPoint}`,
    type: "POST",
    headers: {
      "X-API-Key": API_CONFIG.API_KEY,
      "X-Auth-Token": timestamp,
    },
    data: formData,
    processData: false,
    contentType: false,
    xhrFields: { withCredentials: true },
    success: function (response) {
      console.log("Success:", response);
      if (response.status === 1 && response?.data && response.data.length > 0) {
        // Ensure each traveller has a travellerId
        const travellersWithId = response.data.map((t, index) => ({
          ...t,
          travellerId: t.travellerId || t.id || `temp-${index}`, // Fallback if no ID
        }));
        displaySavedTravellers(travellersWithId);
      } else {
        console.log("No saved travellers found");
        hideSavedTravellersSection();
      }
    },
    error: function (xhr) {
      console.error("Error:", xhr.responseText);
      hideSavedTravellersSection();
    },
  });
}

// Edit saved traveller API call
async function editSavedTravellerAPI(index) {
  console.log("editSavedTravellerAPI called with index:", index);
  console.log("window.savedTravellersData:", window.savedTravellersData);
  console.log("window.isEditMode:", window.isEditMode);
  if (!window.savedTravellersData || !window.savedTravellersData[index]) return;

  const traveller = window.savedTravellersData[index];

  console.log("Editing traveller:", traveller);
  // Check if traveller has travellerId
  if (!traveller.travellerId) {
    alert("Error: Traveller ID not found. Cannot edit this traveller.");
    return;
  }

  // Show loading
  const loadingOverlay = document.createElement("div");
  loadingOverlay.id = "editLoadingOverlay";
  loadingOverlay.style.cssText =
    "position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center; z-index: 9999;";
  loadingOverlay.innerHTML = `
    <div style="background: white; padding: 2rem; border-radius: 12px; text-align: center; max-width: 400px;">
      <div style="font-size: 2rem; margin-bottom: 1rem;">⏳</div>
      <h3 style="margin-bottom: 0.5rem;">Updating Traveller</h3>
      <p style="color: #64748b;">Please wait...</p>
    </div>
  `;
  document.body.appendChild(loadingOverlay);

  // Collect form data - get updated values from form
  const textFields = {
    customerEmail: currentUser?.email || "",
    travellerId: traveller.travellerId,
    travellerTitle:
      document.getElementById("title")?.value ||
      traveller.travellerTitle,
    travellerFirstName:
      document.getElementById("firstName")?.value ||
      traveller.travellerFirstName,
    travellerMiddleName:
      document.getElementById("middleName")?.value ||
      traveller.travellerMiddleName ||
      "",
    travellerLastName:
      document.getElementById("lastName")?.value || traveller.travellerLastName,
    travellerEmail:
      document.getElementById("email")?.value || traveller.travellerEmail ,
    travellerMobile:
      document.getElementById("mobile")?.value || traveller.travellerMobile,
    travellerDob:
      document.getElementById("dob")?.value || traveller.travellerDob,
    travellerCity: "",
    travellerState: "",
    travellerPincode: "",
    travellerAddressLine1: "",
    travellerAddressLine2: "",
    passportNumber:
      document.getElementById("passportNumber")?.value ||
      traveller.passportNumber,
  };

  // Validate required fields
  if (!textFields.customerEmail) {
    alert("Customer email is required. Please login again.");
    const overlay = document.getElementById("editLoadingOverlay");
    if (overlay) overlay.remove();
    return;
  }

  // Create canonical JSON string
  const bodyText = canonicalJSONString(textFields);

  // Get Timestamp and Create HMAC
  const timestamp = Math.floor(Date.now() / 1000);
  const apiEndPoint = API_CONFIG.EDIT_TRAVELLER;
  const message = `POST|${apiEndPoint}|${timestamp}|${bodyText}`;

  const hashData = CryptoJS.HmacSHA256(message, API_CONFIG.SECRET).toString(
    CryptoJS.enc.Hex
  );

  // Prepare FormData
  let formData = new FormData();
  Object.keys(textFields).forEach((key) => {
    formData.append(key, textFields[key]);
  });
  formData.append("hash_data", hashData);

  // Send AJAX
  $.ajax({
    url: `${API_CONFIG.API_URL}${apiEndPoint}`,
    type: "POST",
    headers: {
      "X-API-Key": API_CONFIG.API_KEY,
      "X-Auth-Token": timestamp,
    },
    data: formData,
    processData: false,
    contentType: false,
    xhrFields: { withCredentials: true },
    success: async function (resp) {
      console.log("Edit Traveller Success:", resp);

      // Remove loading overlay
      const overlay = document.getElementById("editLoadingOverlay");
      if (overlay) overlay.remove();

      if (resp.status === 1) {
        // Reset edit mode flags
        window.editingTravellerIndex = null;
        window.editingTravellerData = null;
        window.isEditMode = false;
        // Clear form
        clearFormData();
        showStep(1);
        // Show success message
        alert("Traveller updated successfully!");
        // Refresh travellers list
        await fetchSavedTravellers();
        // Scroll to top to show updated list
        window.scrollTo({ top: 0, behavior: "smooth" });
      } else {
        alert(resp.message || "Failed to update traveller");
      }
    },
    error: function (xhr) {
      console.error("Edit Traveller Error:", xhr.responseText);

      const overlay = document.getElementById("editLoadingOverlay");
      if (overlay) overlay.remove();

      let errorMsg = "Error updating traveller";
      try {
        const errorResp = JSON.parse(xhr.responseText);
        errorMsg = errorResp.message || errorMsg;
      } catch (e) {
        errorMsg = xhr.responseText || errorMsg;
      }

      alert(errorMsg);
    },
  });
}

// Delete saved traveller API call
async function deleteSavedTravellerAPI(index) {
  if (!window.savedTravellersData || !window.savedTravellersData[index]) return;

  const traveller = window.savedTravellersData[index];

  // Check if traveller has travellerId
  if (!traveller.travellerId) {
    alert("Error: Traveller ID not found. Cannot delete this traveller.");
    return;
  }

  const confirmed = confirm(
    `Are you sure you want to delete:\n${traveller.travellerFirstName} ${traveller.travellerLastName}?`
  );

  if (!confirmed) return;

  // Show loading
  const loadingOverlay = document.createElement("div");
  loadingOverlay.id = "deleteLoadingOverlay";
  loadingOverlay.style.cssText =
    "position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center; z-index: 9999;";
  loadingOverlay.innerHTML = `
    <div style="background: white; padding: 2rem; border-radius: 12px; text-align: center; max-width: 400px;">
      <div style="font-size: 2rem; margin-bottom: 1rem;">⏳</div>
      <h3 style="margin-bottom: 0.5rem;">Deleting Traveller</h3>
      <p style="color: #64748b;">Please wait...</p>
    </div>
  `;
  document.body.appendChild(loadingOverlay);

  // Collect form data
  const textFields = {
    customerEmail: currentUser?.email || "",
    travellerId: traveller.travellerId,
  };

  // Validate required fields
  if (!textFields.customerEmail) {
    alert("Customer email is required. Please login again.");
    const overlay = document.getElementById("deleteLoadingOverlay");
    if (overlay) overlay.remove();
    return;
  }

  // Create canonical JSON string
  const bodyText = canonicalJSONString(textFields);

  // Get Timestamp and Create HMAC
  const timestamp = Math.floor(Date.now() / 1000);
  const apiEndPoint = API_CONFIG.DELETE_TRAVELLER;
  const message = `POST|${apiEndPoint}|${timestamp}|${bodyText}`;

  console.log("Delete Traveller - Signing message:", message);

  const hashData = CryptoJS.HmacSHA256(message, API_CONFIG.SECRET).toString(
    CryptoJS.enc.Hex
  );

  console.log("Delete Traveller - hash_data:", hashData);

  // Prepare FormData
  let formData = new FormData();
  Object.keys(textFields).forEach((key) => {
    formData.append(key, textFields[key]);
  });
  formData.append("hash_data", hashData);

  // Send AJAX
  $.ajax({
    url: `${API_CONFIG.API_URL}${apiEndPoint}`,
    type: "POST",
    headers: {
      "X-API-Key": API_CONFIG.API_KEY,
      "X-Auth-Token": timestamp,
    },
    data: formData,
    processData: false,
    contentType: false,
    xhrFields: { withCredentials: true },
    success: async function (resp) {
      console.log("Delete Traveller Success:", resp);

      // Remove loading overlay
      const overlay = document.getElementById("deleteLoadingOverlay");
      if (overlay) overlay.remove();

      if (resp.status === 1) {
        alert("Traveller deleted successfully!");

        // Refresh travellers list
        await fetchSavedTravellers();
      } else {
        alert(resp.message || "Failed to delete traveller");
      }
    },
    error: function (xhr) {
      console.error("Delete Traveller Error:", xhr.responseText);

      const overlay = document.getElementById("deleteLoadingOverlay");
      if (overlay) overlay.remove();

      let errorMsg = "Error deleting traveller";
      try {
        const errorResp = JSON.parse(xhr.responseText);
        errorMsg = errorResp.message || errorMsg;
      } catch (e) {
        errorMsg = xhr.responseText || errorMsg;
      }

      alert(errorMsg);
    },
  });
}

// Display saved travellers in grid
function displaySavedTravellers(travellersData) {
  const section = document.getElementById("savedTravellersSection");
  const list = document.getElementById("savedTravellersList");

  if (!section || !list) return;

  list.innerHTML = travellersData
    .map(
      (traveller, index) => `
    <div class="saved-traveller-row" data-index="${index}">
      <div class="saved-traveller-checkbox">
        <input type="radio" 
              name="selectedTraveller"
               id="savedTraveller${index}" 
               onchange="toggleTravellerSelection(${index})"
               data-index="${index}">
      </div>
      <div class="saved-traveller-content">
        <div class="saved-traveller-field">
          <span class="saved-traveller-label">Name</span>
          <span class="saved-traveller-value">${traveller.travellerTitle}. ${traveller.travellerFirstName} ${traveller.travellerLastName}</span>
        </div>
        <div class="saved-traveller-field">
          <span class="saved-traveller-label">Email</span>
          <span class="saved-traveller-value">${traveller.travellerEmail}</span>
        </div>
        <div class="saved-traveller-field">
          <span class="saved-traveller-label">Mobile</span>
          <span class="saved-traveller-value">${traveller.travellerMobile}</span>
        </div>
        <div class="saved-traveller-field">
          <span class="saved-traveller-label">Passport</span>
          <span class="saved-traveller-value passport">${traveller.passportNumber}</span>
        </div>
      </div>
      <div class="saved-traveller-actions-btns">
        <button class="saved-traveller-btn edit" onclick="editSavedTraveller(${index})" title="Edit">
          ✏️
        </button>
        <button class="saved-traveller-btn delete" onclick="deleteSavedTraveller(${index})" title="Delete">
          🗑️
        </button>
      </div>
    </div>
  `
    )
    .join("");

  // Store travellers data globally
  window.savedTravellersData = travellersData;
  window.selectedTravellerIndex = null;

  // Show section
  section.classList.remove("hidden");

  // Update button state
  updateContinueButton();
}

// Hide saved travellers section
function hideSavedTravellersSection() {
  const section = document.getElementById("savedTravellersSection");
  if (section) {
    section.classList.add("hidden");
  }
}

// Toggle traveller selection
function toggleTravellerSelection(index) {
  const radio = document.getElementById(`savedTraveller${index}`);
  const allRows = document.querySelectorAll('.saved-traveller-row');

  if (!radio) return;

  // Remove selected class from all rows
  allRows.forEach(row => row.classList.remove('selected'));

  // Add selected class to current row
  const row = document.querySelector(`.saved-traveller-row[data-index="${index}"]`);
  if (row && radio.checked) {
    row.classList.add("selected");
    window.selectedTravellerIndex = index;
  } else {
    window.selectedTravellerIndex = null;
  }

  updateContinueButton();
}

// Update continue button state
function updateContinueButton() {
  const btn = document.getElementById("btnContinueWithSelected");
   //const countSpan = document.getElementById("selectedCount");

  if (!btn ) return;

  if (window.selectedTravellerIndex !== null && window.selectedTravellerIndex !== undefined) {
    btn.style.display = "block";
  } else {
    btn.style.display = "none";
  }
}

// Edit saved traveller - Show form with pre-filled data
function editSavedTraveller(index) {
  if (!window.savedTravellersData || !window.savedTravellersData[index]) return;

  const traveller = window.savedTravellersData[index];
 
  // Store the index for editing
  window.editingTravellerIndex = index;
  window.editingTravellerData = traveller;
  window.isEditMode = true; 

  // Show the form
  showAddNewTravellerForm();

  // Pre-fill form with selected traveller data
  document.getElementById("title").value =
    traveller.travellerTitle || "";
  document.getElementById("firstName").value =
    traveller.travellerFirstName || "";
  document.getElementById("middleName").value =
    traveller.travellerMiddleName || "";
  document.getElementById("lastName").value = traveller.travellerLastName || "";
  document.getElementById("email").value = traveller.travellerEmail || "";
  document.getElementById("mobile").value = traveller.travellerMobile || "";
  document.getElementById("passportNumber").value =
    traveller.passportNumber || "";
  document.getElementById("dob").value = traveller.travellerDob || "";
  document.getElementById("gender").value = traveller.gender || "";
  document.getElementById("occupation").value = traveller.occupation || "";
  document.getElementById("passportExpiry").value =
    traveller.passportExpiry || "";
  // document.getElementById("skipPassportUpload").checked = true;

  // Set passportDataFetched flag to true so that the Passport API is not called again and the existing data is preloaded
  window.passportDataFetched = true;

  // Upload files from URLs
  (async () => {
    await Promise.all([
      setFileInputAndPreviewFromUrl(
        "travelerPhotoFile",
        "travelerPhotoPreview",
        traveller.travellerImagePath,
        "traveller_photo"
      ),
      setFileInputAndPreviewFromUrl(
        "passportFrontFile",
        "passportFrontPreview",
        traveller.passportFrontPath,
        "passport_front"
      ),
      setFileInputAndPreviewFromUrl(
        "passportBackFile",
        "passportBackPreview",
        traveller.passportBackPath,
        "passport_back"
      )
    ]);
  })();

  // Show personal details section
  const personalDetailsSection = document.getElementById(
    "personalDetailsSection"
  );
  if (personalDetailsSection) {
    personalDetailsSection.style.display = "block";
    const formGrids = personalDetailsSection.querySelectorAll(".form-grid");
    const headings = personalDetailsSection.querySelectorAll("h3");
    formGrids.forEach((grid) => (grid.style.display = "grid"));
    headings.forEach((heading) => (heading.style.display = "block"));
  }
}
// Show Add New Traveller Form
function showAddNewTravellerForm() {
  const section = document.getElementById("savedTravellersSection");
  const detailsForm = document.getElementById("travellerDetailsForm");

  if (section) {
    section.classList.add("hidden");
  }
  if (detailsForm) {
    detailsForm.classList.remove("hidden");
  }

  // Clear any selections
  document.querySelectorAll('input[name="selectedTraveller"]').forEach((radio) => {
    radio.checked = false;
  });
  document.querySelectorAll(".saved-traveller-row").forEach((row) => {
    row.classList.remove("selected");
  });
  window.selectedTravellerIndex = null;
  // IMPORTANT: Only reset edit mode if not currently editing
  if (!window.isEditMode) {
    window.editingTravellerIndex = null;
    window.editingTravellerData = null;
  }

  // Scroll to form
  window.scrollTo({ top: 0, behavior: "smooth" });
}

// Delete saved traveller - Call API
function deleteSavedTraveller(index) {
  deleteSavedTravellerAPI(index);
}

// Script from Visa Selector Page

// Continue with selected travellers
function continueWithSelectedTravellers() {
  if (window.selectedTravellerIndex === null || window.selectedTravellerIndex === undefined) {
    alert("Please select a traveller");
    return;
  }


  // Get selected traveller data
  const traveller = window.savedTravellersData[window.selectedTravellerIndex];

  // Set passportDataFetched flag to true so that the Passport API is not called again and the existing data is preloaded
  window.passportDataFetched = true;
  
  // Pre-fill form with selected traveller data
  document.getElementById("title").value = traveller.travellerTitle || "";
  document.getElementById("firstName").value = traveller.travellerFirstName || "";
  document.getElementById("middleName").value = traveller.travellerMiddleName || "";
  document.getElementById("lastName").value = traveller.travellerLastName || "";
  document.getElementById("email").value = traveller.travellerEmail || "";
  document.getElementById("mobile").value = traveller.travellerMobile || "";
  document.getElementById("passportNumber").value = traveller.passportNumber || "";
  document.getElementById("dob").value = traveller.travellerDob || "";
  document.getElementById("gender").value = traveller.gender || "";
  document.getElementById("occupation").value = traveller.occupation || "";
  document.getElementById("passportExpiry").value = traveller.passportExpiry || "";

  // Upload files from URLs
  (async () => {
    await Promise.all([
      setFileInputAndPreviewFromUrl(
        "travelerPhotoFile",
        "travelerPhotoPreview",
        traveller.travellerImagePath,
        "traveller_photo"
      ),
      setFileInputAndPreviewFromUrl(
        "passportFrontFile",
        "passportFrontPreview",
        traveller.passportFrontPath,
        "passport_front"
      ),
      setFileInputAndPreviewFromUrl(
        "passportBackFile",
        "passportBackPreview",
        traveller.passportBackPath,
        "passport_back"
      )
    ]);
  })();
  
  // Show personal details section
  const personalDetailsSection = document.getElementById("personalDetailsSection");
  if (personalDetailsSection) {
    personalDetailsSection.style.display = "block";
    const formGrids = personalDetailsSection.querySelectorAll(".form-grid");
    const headings = personalDetailsSection.querySelectorAll("h3");
    formGrids.forEach((grid) => (grid.style.display = "grid"));
    headings.forEach((heading) => (heading.style.display = "block"));
  }

  // Hide saved travellers section
  const section = document.getElementById("savedTravellersSection");
  if (section) {
    section.classList.add("hidden");
  }

  // Go to step 3
   showStep(3);
   update();
  
  //  initiatlisePage2();

  const dob= document.getElementById("dob").value;
  console.log("Continue with selected traveller dob",dob);
  filterCard(dob);
  window.scrollTo({ top: 0, behavior: "smooth" });
}

function resetPassportUpload(element, originalText, originalSubtitle) {
  if (element) {
    const uploadText = element.querySelector(".upload-text");
    const uploadSubtitle = element.querySelector(".upload-subtitle");

    if (uploadText) uploadText.textContent = originalText;
    if (uploadSubtitle) uploadSubtitle.textContent = originalSubtitle;

    element.style.borderColor = "#cbd5e1";
    element.style.backgroundColor = "#f8fafc";
    element.classList.remove("uploaded");
  }
}

// function handleUpload(
//   uploadElement,
//   title,
//   key,
//   acceptTypes = ".pdf,.jpg,.jpeg,.png"
// ) {
//   // if (!uploadElement) return;
//  if (!uploadElement || uploadElement.dataset.listenerAdded) return;
//   uploadElement.dataset.listenerAdded = "true";
//   uploadElement.addEventListener("click", function () {
//     // Don't proceed if uploads are disabled (for passport uploads)
//     if (uploadElement.id.includes("passport")) {
//       const passportUploads = document.getElementById("passportUploads");
//       if (passportUploads && passportUploads.classList.contains("disabled")) {
//         return;
//       }
//     }
//      const fileInput = uploadElement.querySelector('input[type="file"]') ||
//                     document.getElementById(`${uploadElement.id}File`);

//         if (!fileInput) return;
//          fileInput.addEventListener("change", function (e) {
//     if (e.target.files.length > 0) {
//       const file = e.target.files[0];
//       const fileName = file.name;
//       uploadedFiles[key] = file;

//       const uploadText = uploadElement.querySelector(".upload-text");
//       const uploadSubtitle = uploadElement.querySelector(".upload-subtitle");

//       if (uploadText) uploadText.textContent = `Uploaded: ${fileName}`;
//       if (uploadSubtitle)
//         uploadSubtitle.textContent = "File uploaded successfully!";
//       uploadElement.classList.add("uploaded");

//       checkAllUploadsAndTriggerAPI();
//     }
//   });
//     // const fileInput = document.createElement("input");
//     // fileInput.type = "file";
//     // fileInput.accept = acceptTypes;
//     // fileInput.style.display = "none";

//     // fileInput.addEventListener("change", function (e) {
//     //   if (e.target.files.length > 0) {
//     //     const file = e.target.files[0];
//     //     const fileName = e.target.files[0].name;
//     //     // Save file to uploadedFiles object
//     //     uploadedFiles[key] = file;
//     //     const uploadText = uploadElement.querySelector(".upload-text");
//     //     const uploadSubtitle = uploadElement.querySelector(".upload-subtitle");

//     //     if (uploadText) uploadText.textContent = `Uploaded: ${fileName}`;
//     //     if (uploadSubtitle)
//     //       uploadSubtitle.textContent = "File uploaded successfully!";
//     //     uploadElement.classList.add("uploaded");
//     //     // Check if all three uploads are completed
//     //     checkAllUploadsAndTriggerAPI();
//     //   }
//     // });

//     document.body.appendChild(fileInput);
//     fileInput.click();
//     document.body.removeChild(fileInput);
//   });
// }
// // Check if all three uploads are done and trigger API
// function checkAllUploadsAndTriggerAPI() {
//   const passportFrontUpload = document.getElementById("passportFrontUpload");
//   const passportBackUpload = document.getElementById("passportBackUpload");
//   const travelerPhotoUpload = document.getElementById("travelerPhotoUpload");
//   const personalDetailsSection = document.getElementById(
//     "personalDetailsSection"
//   );

//   const frontUploaded = passportFrontUpload.classList.contains("uploaded");
//   const backUploaded = passportBackUpload.classList.contains("uploaded");
//   const photoUploaded = travelerPhotoUpload.classList.contains("uploaded");

//   // Show personal details and trigger API when all three are uploaded
//   if (
//     frontUploaded &&
//     backUploaded &&
//     photoUploaded &&
//     personalDetailsSection
//   ) {
//     personalDetailsSection.style.display = "block";

//     // Trigger API call to fetch and prepopulate data
//     fetchPassportDataFromAPI();
//   }
// }
function handleUpload(uploadElement, title, key, acceptTypes = ".pdf,.jpg,.jpeg,.png") {
  if (!uploadElement || uploadElement.dataset.listenerAdded) return;
  uploadElement.dataset.listenerAdded = "true";

  const fileInput = uploadElement.querySelector('input[type="file"]') ||
                    document.getElementById(`${uploadElement.id}File`);

  if (!fileInput) return;

  // Handle file change event
  fileInput.addEventListener("change", function (e) {
    if (e.target.files.length > 0) {
      const file = e.target.files[0];
      const fileName = file.name;
      uploadedFiles[key] = file;
      
        if (file.type.startsWith('image/')) {
          const reader = new FileReader();
          reader.onload = function(readerEvent) {
            const base64Image = readerEvent.target.result;
            // Store base64 in uploadedFiles for later use
            uploadedFiles[key + '_base64'] = base64Image;
            // Save progress immediately after image conversion
            saveProgress();
          };
          reader.readAsDataURL(file);
        }

      // Update text
      const uploadText = uploadElement.querySelector(".upload-text");
      const uploadSubtitle = uploadElement.querySelector(".upload-subtitle");
      const previewImg = uploadElement.querySelector(".photo-preview img");

      if (uploadText) uploadText.textContent = `Uploaded: ${fileName}`;
      if (uploadSubtitle)
        uploadSubtitle.textContent = "File uploaded successfully!";

      // Show preview image if it's an image file
      if (previewImg && file.type.startsWith("image/")) {
        const reader = new FileReader();
        reader.onload = function (e) {
          previewImg.src = e.target.result;
        };
        reader.readAsDataURL(file);
      }

      uploadElement.classList.add("uploaded");

      checkAllUploadsAndTriggerAPI();
    }
  });

  // If it's not a <label>, make it clickable manually
  if (uploadElement.tagName.toLowerCase() !== "label") {
    uploadElement.addEventListener("click", function () {
      // Prevent opening if disabled
      if (uploadElement.id.includes("passport")) {
        const passportUploads = document.getElementById("passportUploads");
        if (passportUploads && passportUploads.classList.contains("disabled")) {
          return;
        }
      }
      fileInput.click();
    });
  }
}

function checkAllUploadsAndTriggerAPI() {
  const passportFrontUpload = document.getElementById("passportFrontUpload");
  const passportBackUpload = document.getElementById("passportBackUpload");
  const travelerPhotoUpload = document.getElementById("travelerPhotoUpload");
  const personalDetailsSection = document.getElementById("personalDetailsSection");

  const frontUploaded = passportFrontUpload.classList.contains("uploaded");
  const backUploaded = passportBackUpload.classList.contains("uploaded");
  const photoUploaded = travelerPhotoUpload.classList.contains("uploaded");

  if (frontUploaded && backUploaded && photoUploaded && personalDetailsSection) {
    personalDetailsSection.style.display = "block";
    fetchPassportDataFromAPI();
  }
}


// Next button logic with updated validation
document.querySelectorAll(".next-btn").forEach((btn) => {
  btn.addEventListener("click", function (e) {
    let allValid = true;

    if (currentStep === 1) {
      allValid = validateStep1();
      if (allValid){
        // Normalize for comparison
        const selectedVisitType = selectedData.visitType?.trim().toLowerCase();
        const selectedStayPeriod = selectedData.travelDays?.toString().trim().toLowerCase();

        // Loop through all cards
        document.querySelectorAll(".visa-card").forEach(card => {
          const visitType = card.dataset.visitType?.trim().toLowerCase();
          const stayPeriod = card.dataset.stayPeriod?.toString().trim().toLowerCase();

          // Show only if both match
          if (visitType === selectedVisitType && stayPeriod === selectedStayPeriod) {
            card.style.display = "flex"; // or "block"
          } else {
            card.style.display = "none";
          }
        });
      }
    }
    else if (currentStep === 2) {
      allValid = validateStep2();
        if(allValid){
          const age=document.getElementById("dob").value;
           filterCard(age);
          }
 
    }
    else if (currentStep === 3) {
      allValid = validateStep3();
     
    } 
    else if (currentStep === 4) {
      allValid = validateStep4();
    }

    if (allValid && currentStep < 5) {
      showStep(currentStep + 1);
      update();
    }
  });
});

// Back button logic
document.querySelectorAll(".prev-btn").forEach((btn) => {
  btn.addEventListener("click", function () {
    if (currentStep > 1) {
      showStep(currentStep - 1);
        update();
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  });
});


  //filtering the card based on age calculation
  // function filterCard(dob){
  //   console.log(" DOB Of Traveller->",dob);
  //     const age= calculateAgeFromDOB(dob);
  //     console.log("Age of Traveller->",age);
  //     const cardStay=selectedData["travelDays"];
  //     console.log("Days Difference->" , cardStay);
 
  //     const allCards=document.querySelectorAll('.visa-card');
  //     allCards.forEach(card => {
  //       const minAge=parseInt(card.dataset.minimumAge || "0");
  //       const maxAge=parseInt(card.dataset.maximumAge || "150");
  //       const travel=parseInt(card.dataset.stayPeriod || "0");
        
  //        const ageValid = age >= minAge && age <= maxAge;
  //        const daysValid = cardStay === travel;

  //       if(ageValid && daysValid){
  //         card.style.display="flex";
  //       }else{
  //         card.style.display="none";
  //       }
  //     });  
  // }

  function filterCard(dob) {
    let count=0;
    // show the card if no plan 
    const noPlansMsg = document.getElementById("noPlansMessage");

    const age = calculateAgeFromDOB(dob);
    const cardStay = Number(selectedData["travelDays"]);
    const startDateValue = document.getElementById("travelStartDate").value;
    if (!startDateValue) return;

    const travelStartDate = new Date(startDateValue);
    travelStartDate.setHours(0, 0, 0, 0);

    //  ADD TODAY + 1
    const allowedDate = new Date(travelStartDate);
    allowedDate.setDate(allowedDate.getDate() + 1);

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    document.querySelectorAll(".visa-card").forEach(card => {
      const minAgeRaw = card.dataset.minimumAge;
      const maxAgeRaw = card.dataset.maximumAge;
      const stayRaw   = card.dataset.stayPeriod;
      const minAppointmentRaw = card.dataset.minimumAppointmentDays;
      console.log({
        age,
        minAge: card.dataset.minimumAge,
        maxAge: card.dataset.maximumAge,
        minAppointment:minAppointmentRaw,
      });

      // HARD GUARDS — if data missing, hide card
      if (!minAgeRaw || !maxAgeRaw || !stayRaw || !minAppointmentRaw) {
        card.style.display = "none";
        return;
      }
      
      const minAge = Number(minAgeRaw);
      const maxAge = Number(maxAgeRaw);
      const travel = Number(stayRaw);
      const minAppointmentDays = Number(minAppointmentRaw);
      const ageValid  = age >= minAge && age <= maxAge;
      // const daysValid = cardStay === travel;
      
      // Check if the stay period is greater than or equal to the travel days
      const daysValid = travel >= cardStay;
      const appointmentAvailableDate = new Date(today);
      appointmentAvailableDate.setDate(today.getDate() + minAppointmentDays);

      // ✅ CORE CONDITION (start date + 1)
      //  const appointmentValid = appointmentAvailableDate <= allowedDate;
     const appointmentValid = appointmentAvailableDate <= travelStartDate;
       if(ageValid && daysValid && appointmentValid) count++;
      card.style.display = (ageValid && daysValid && appointmentValid) ? "flex" : "none";

    });
       if (count === 0) {
          noPlansMsg.classList.remove("hidden");
      } else {
         noPlansMsg.classList.add("hidden");
    }
  }

// Sidebar click navigation
document.querySelectorAll(".sidebar-item").forEach((item) => {
  item.addEventListener("click", function () {
    const targetStep = Number(this.dataset.step);
    // Only allow navigation to previous steps or current step
    if (targetStep <= currentStep) {
      showStep(targetStep);
        update();
    }
  });
});

const generateTravellerId = () => {
  const timestamp = Date.now();
  const randomNum = Math.floor(Math.random() * 10000);
  return `${timestamp}${randomNum}`;
};


function proceedToPayment() {
  console.log("isEditMode:", window.isEditMode);
  console.log("editingTravellerIndex:", window.editingTravellerIndex);
  // Check if user is logged in
  console.log(userLoggedIn, "userLoggedIn");
  // if (!userLoggedIn) {
  //   showAuthModal("login");
  //   // Store a flag to continue after login
  //   window.pendingProceedToPayment = true;
  //   return;
  // }
  // Check if in edit mode
  if (
    window.isEditMode &&
    window.editingTravellerIndex !== null &&
    window.editingTravellerIndex !== undefined
  ) {
    console.log("Edit mode detected, calling editSavedTravellerAPI");
    editSavedTravellerAPI(window.editingTravellerIndex);
  } else {
         console.log("Normal mode, calling saveTravellerData");
         saveTravellerData();
  }
}

function saveTravellerData() {
  const loadingOverlay = document.createElement("div");
  loadingOverlay.id = "paymentLoadingOverlay";
  loadingOverlay.style.cssText =
    "position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center; z-index: 9999;";
  loadingOverlay.innerHTML = `
    <div style="background: white; padding: 2rem; border-radius: 12px; text-align: center; max-width: 400px;">
      <div style="font-size: 2rem; margin-bottom: 1rem;">⏳</div>
      <h3 style="margin-bottom: 0.5rem;">Saving Traveller Details</h3>
      <p style="color: #64748b;">Please wait...</p>
    </div>
  `;
  document.body.appendChild(loadingOverlay);
  // Get customer email from logged in user
  const customerEmail = currentUser?.email || "";

  console.log("Current User:", currentUser);
  console.log("Customer Email:", customerEmail);

  // Collect ALL form data including gender, occupation, passportExpiry
  const textFields = {
    travellerId:
      currentEditingIndex >= 0
        ? travellers[currentEditingIndex].travellerId
        : generateTravellerId(),
    travellerTitle: document.getElementById("title")?.value || "",
    travellerFirstName: document.getElementById("firstName")?.value || "",
    travellerMiddleName: document.getElementById("middleName")?.value || "",
    travellerLastName: document.getElementById("lastName")?.value || "",
    travellerEmail: document.getElementById("email")?.value || "",
    travellerMobile: document.getElementById("mobile")?.value || "",
    passportNumber: document.getElementById("passportNumber")?.value || "",
    travellerDob: document.getElementById("dob")?.value || "",
    gender: document.getElementById("gender")?.value || "",
    occupation: document.getElementById("occupation")?.value || "",
    passportExpiry: document.getElementById("passportExpiry")?.value || "",
    travelStartDate: document.getElementById("travelStartDate")?.value || "",
    travelEndDate: document.getElementById("travelEndDate")?.value || "",
    customerEmail: customerEmail, 
    variantId: selectedData['variantId'],
    visaFee: selectedData['visaFee'],
    govtFee: selectedData['govtFee'],
    serviceTax: selectedData['serviceTax'],
    matrixGovtFee: selectedData['matrixGovtFee'],
    matrixFee: selectedData['matrixFee'],
    price: selectedData['price']
  };

  const bodyText = canonicalJSONString(textFields);
  const timestamp = Math.floor(Date.now() / 1000);
  const apiEndPoint = API_CONFIG.SAVE_TRAVELLER_ENDPOINT;
  const message = `POST|${apiEndPoint}|${timestamp}|${bodyText}`;

  console.log("Signing message for save:", message);

  const hashData = CryptoJS.HmacSHA256(message, API_CONFIG.SECRET).toString(
    CryptoJS.enc.Hex
  );
  console.log("hash_data for save:", hashData);

  let formData = new FormData();
  Object.keys(textFields).forEach((key) => {
    formData.append(key, textFields[key]);
  });

  if (uploadedFiles.passportFront) {
    formData.append("passportFront", uploadedFiles.passportFront);
  }
  if (uploadedFiles.passportBack) {
    formData.append("passportBack", uploadedFiles.passportBack);
  }
  if (uploadedFiles.travellerImage) {
    formData.append("travellerImage", uploadedFiles.travellerImage);
  }

  const flightFile = document.getElementById("flightFile");
  const hotelFile = document.getElementById("hotelFile");
  // const bankFile = document.getElementById("bankFile");
  console.log("Flight File",flightFile.files[0])
  console.log("Hotl File",hotelFile.files[0])
  // console.log("bank  File",bankFile.files[0])
  if (flightFile && flightFile.files.length > 0) {
    formData.append("flightTicket", flightFile.files[0]);
  }
  if (hotelFile && hotelFile.files.length > 0) {
    formData.append("hotelBooking", hotelFile.files[0]);
  }
  // if (bankFile && bankFile.files.length > 0) {
  //   formData.append("bankStatement", bankFile.files[0]);
  // }

  formData.append("hash_data", hashData);
  console.log(formData, "formDataformDataformData");

  $.ajax({
    url: `${API_CONFIG.API_URL}${apiEndPoint}`,
    type: "POST",
    headers: {
      "X-API-Key": API_CONFIG.API_KEY,
      "X-Auth-Token": timestamp,
    },
    data: formData,
    processData: false,
    contentType: false,
    xhrFields: { withCredentials: true },
    success: function (resp) {
      console.log("Save Success:", resp);

      const overlay = document.getElementById("paymentLoadingOverlay");
      if (overlay) {
        overlay.remove();
      }
      // Create traveller object with ALL fields including checkbox state
      const skipPassportChecked =
        document.getElementById("skipPassportUpload")?.checked || false;

      const travellerData = {
        ...textFields,
        applicationId: resp.applicationId || textFields.travellerId,
        skipPassportUpload: skipPassportChecked,
        hasPassportFront: !!uploadedFiles.passportFront,
        hasPassportBack: !!uploadedFiles.passportBack,
        hasTravellerImage: !!uploadedFiles.travellerImage,
        hasFlightTicket: flightFile && flightFile.files.length > 0,
        hasHotelBooking: hotelFile && hotelFile.files.length > 0,
        // hasBankStatement: bankFile && bankFile.files.length > 0,
        images: {
          passportFront: uploadedFiles.passportFront_base64 || "",
          passportBack: uploadedFiles.passportBack_base64 || "",
          travellerImage: uploadedFiles.travellerImage_base64 || "",
        }
      };

      if (currentEditingIndex >= 0) {
        travellers[currentEditingIndex] = travellerData;
      } else {
        travellers.push(travellerData);
      }

      currentEditingIndex = -1;
      clearFormData();
      showStep(1);
        update();
      showSuccessMessage();
      updateOngoingApplicationCard();
      saveProgress();
    },
    error: function (xhr) {
      console.error("Save Error:", xhr.responseText);

      const overlay = document.getElementById("paymentLoadingOverlay");
      if (overlay) {
        overlay.remove();
      }

      alert(
        "Error saving application:\n\n" +
          (xhr.responseText || "Please try again or contact support.")
      );
    },
  });
}
function displaySidebarTravellers() {
  const sidebarList = document.getElementById("sidebarTravellersList");
  if (!sidebarList) return;

  if (!travellers || travellers.length === 0) {
    sidebarList.innerHTML =
      '<p style="text-align: center; color: #64748b; padding: 1rem; font-size: 0.85rem;">No travellers added yet</p>';
    return;
  }

  sidebarList.innerHTML = travellers
    .map(
      (traveller, index) => `
    <div class="sidebar-traveller-item">
      <div class="sidebar-traveller-main">
        <div class="sidebar-traveller-number">${index + 1}</div>
        <div class="sidebar-traveller-info">
          <div class="sidebar-traveller-name">${traveller.travellerTitle}. ${traveller.travellerFirstName} ${
        traveller.travellerLastName
      }</div>
          <div class="sidebar-traveller-passport">${
            traveller.passportNumber
          }</div>
        </div>
      </div>
      <div class="sidebar-traveller-actions">
        <button class="sidebar-btn-edit" onclick="editTraveller(${index})" title="Edit">✏️</button>
        <button class="sidebar-btn-delete" onclick="deleteTraveller(${index})" title="Delete">🗑️</button>
      </div>
    </div>
  `
    )
    .join("");
  // Force display
  sidebarList.style.display = "block";
}
function updateOngoingApplicationCard() {
  const savedProgressCard = document.getElementById("savedProgressCard");
  const progressDateEl = document.getElementById("progressDate");
  const progressStepEl = document.getElementById("progressStep");
  const progressTravellersEl = document.getElementById("progressTravellers");
  const btnProceedPayment = document.getElementById("btnProceedPayment");
  const btnResume = document.getElementById("btnResume");

  if (savedProgressCard && travellers.length > 0) {
    savedProgressCard.classList.remove("hidden");

    if (progressDateEl) {
      progressDateEl.textContent = `Last saved: ${new Date().toLocaleDateString()}`;
    }

    if (progressStepEl) {
      progressStepEl.textContent = `Step: Ready for more travellers`;
    }

    if (progressTravellersEl) {
      progressTravellersEl.textContent = `Travellers: ${travellers.length}`;
    }

    // Show appropriate buttons
    if (btnProceedPayment) btnProceedPayment.style.display = "none";
    if (btnResume) btnResume.style.display = "none";

    // Display travellers in sidebar
    setTimeout(() => {
      displaySidebarTravellers();
    }, 50);
  }
}
function showSuccessMessage() {
  const overlay = document.getElementById("successMessageOverlay");
  const countEl = document.getElementById("successTravellerCount");
  const amountEl = document.getElementById("successTotalAmount");

  if (overlay) {
    // Update count and amount
    if (countEl) countEl.textContent = travellers.length;
    if (amountEl) {
      const total = travellers.reduce((sum, item) => sum + (item.price || 0), 0);
      amountEl.textContent = total.toLocaleString();
    }

    // Show overlay
    overlay.classList.remove("hidden");
    setTimeout(() => {
      overlay.classList.add("active");
    }, 10);
  }
}
function hideSuccessMessage() {
  const overlay = document.getElementById("successMessageOverlay");
  if (overlay) {
    overlay.classList.remove("active");
    setTimeout(() => {
      overlay.classList.add("hidden");
    }, 300);
  }
}

function addNewTraveller() {
  currentEditingIndex = -1;
  // Reset edit mode flags
  window.isEditMode = false;
  window.editingTravellerIndex = null;
  window.editingTravellerData = null;
  clearFormData();

  // Hide success message
  hideSuccessMessage();

  // Keep ongoing card visible - update it to show current travellers
  if (travellers.length > 0) {
    const savedProgressCard = document.getElementById("savedProgressCard");
    if (savedProgressCard) {
      savedProgressCard.classList.remove("hidden");
    }
    updateOngoingApplicationCard();
  }

  showStep(1);
    update();
  window.scrollTo({ top: 0, behavior: "smooth" });
}

// function editTraveller(index) {
//   console.log("Editing traveller - ",index);
//   if (index < 0 || index >= travellers.length) return;

//   currentEditingIndex = index;
//   const traveller = travellers[index];
  
//   // Keep ongoing card visible during edit
//   const savedProgressCard = document.getElementById("savedProgressCard");
//   if (savedProgressCard) {
//     savedProgressCard.classList.remove("hidden");
//   }

//   // Populate form with traveller data
//   document.getElementById("firstName").value = traveller.travellerFirstName;
//   document.getElementById("middleName").value =traveller.travellerMiddleName || "";
//   document.getElementById("lastName").value = traveller.travellerLastName;
//   document.getElementById("email").value = traveller.travellerEmail;
//   document.getElementById("mobile").value = traveller.travellerMobile;
//   document.getElementById("passportNumber").value = traveller.passportNumber;
//   document.getElementById("dob").value = traveller.travellerDob;
//   document.getElementById("gender").value = traveller.gender || "";
//   document.getElementById("occupation").value = traveller.occupation || "";
//   document.getElementById("passportExpiry").value =traveller.passportExpiry || "";

//   //  Restore checkbox state
//   // const skipCheckbox = document.getElementById("skipPassportUpload");
//   // if (skipCheckbox && traveller.skipPassportUpload === true) {
//   //   skipCheckbox.checked = true;

//   //   // Apply skip effects
//   //   const passportUploads = document.getElementById("passportUploads");
//   //   const travelerPhotoUpload = document.getElementById("travelerPhotoUpload");

//   //   if (passportUploads) {
//   //     passportUploads.classList.add("disabled");
//   //   }
//   //   if (travelerPhotoUpload) {
//   //     travelerPhotoUpload.classList.add("disabled");
//   //     travelerPhotoUpload.style.opacity = "0.5";
//   //     travelerPhotoUpload.style.pointerEvents = "none";
//   //   }
//   // } else if (skipCheckbox) {
//   //   skipCheckbox.checked = false;
//   // }
//   // Populate step 2 data if available
//   if (traveller.travelStartDate) {
//     document.getElementById("travelStartDate").value =
//       traveller.travelStartDate;
//   }
//   if (traveller.travelEndDate) {
//     document.getElementById("travelEndDate").value = traveller.travelEndDate;
//   }
//   //Restore upload states in edit mode
//   if (traveller.hasPassportFront) {
//     markAsUploaded("passportFrontUpload", "Passport front (saved)");
//   }
//   if (traveller.hasPassportBack) {
//     markAsUploaded("passportBackUpload", "Passport back (saved)");
//   }
//   if (traveller.hasTravellerImage) {
//     markAsUploaded("travelerPhotoUpload", "Photo (saved)");
//   }

//   // Show personal details section
//   const personalDetailsSection = document.getElementById(
//     "personalDetailsSection"
//   );
//   if (personalDetailsSection) {
//     personalDetailsSection.style.display = "block";
//     const formGrids = personalDetailsSection.querySelectorAll(".form-grid");
//     const headings = personalDetailsSection.querySelectorAll("h3");
//     formGrids.forEach((grid) => (grid.style.display = "grid"));
//     headings.forEach((heading) => (heading.style.display = "block"));
//   }

//   // Go to step 1
//   showStep(1);
//     update();
//   // Scroll to top
//   window.scrollTo({ top: 0, behavior: "smooth" });
// }

function editTraveller(index) {
  window.isEditMode=true;
  if (index < 0 || index >= travellers.length) return;

  currentEditingIndex = index;
  const traveller = travellers[index];
  
  // Keep saved progress visiblse
  const savedProgressCard = document.getElementById("savedProgressCard");
  if (savedProgressCard) {
    savedProgressCard.classList.remove("hidden");
  }
  // Fill personal details
  document.getElementById("title").value = traveller.travellerTitle;
  document.getElementById("firstName").value = traveller.travellerFirstName;
  document.getElementById("middleName").value = traveller.travellerMiddleName || "";
  document.getElementById("lastName").value = traveller.travellerLastName;
  document.getElementById("email").value = traveller.travellerEmail;
  document.getElementById("mobile").value = traveller.travellerMobile;
  document.getElementById("passportNumber").value = traveller.passportNumber;
  document.getElementById("dob").value = traveller.travellerDob;
  document.getElementById("gender").value = traveller.gender || "";
  document.getElementById("occupation").value = traveller.occupation || "";
  document.getElementById("passportExpiry").value = traveller.passportExpiry || "";
  
  
  if (traveller.travelStartDate) {
    document.getElementById("travelStartDate").value = traveller.travelStartDate;
  }

  if (traveller.travelEndDate) {
    document.getElementById("travelEndDate").value = traveller.travelEndDate;
  }

  // Restore uploaded file states
  if (traveller.hasPassportFront) {
    // markAsUploaded("passportFrontUpload", "Passport front (saved)");
    // uploadedFiles.passportFront_base64 = traveller.images.passportFront;

    // Set passportDataFetched flag to true so that the Passport API is not called again and the existing data is preloaded
    window.passportDataFetched = true;

    setFileInputFromBase64(
      "passportFrontFile",
      "passportFrontPreview",
      traveller.images.passportFront,
      "passport-front"
    );
    markAsUploaded("passportFrontUpload", "Passport front (saved)");
  }
  if (traveller.hasPassportBack) {
    // markAsUploaded("passportBackUpload", "Passport back (saved)");
    // uploadedFiles.passportBack_base64 = traveller.images.passportBack;
    setFileInputFromBase64(
      "passportBackFile",
      "passportBackPreview",
      traveller.images.passportBack,
      "passport-back"
    );
    markAsUploaded("passportBackUpload", "Passport back (saved)");
  }
  if (traveller.hasTravellerImage) {
    // markAsUploaded("travelerPhotoUpload", "Photo (saved)");
    // uploadedFiles.travellerImage_base64 = traveller.images.travellerImage;
    setFileInputFromBase64(
      "travelerPhotoFile",
      "travelerPhotoPreview",
      traveller.images.travellerImage,
      "traveller-image"
    );
    markAsUploaded("travelerPhotoUpload", "Photo (saved)");
  }

  // Show Personal Details section
  const personalDetailsSection = document.getElementById("personalDetailsSection");
  if (personalDetailsSection) {
    personalDetailsSection.style.display = "block";
    const formGrids = personalDetailsSection.querySelectorAll(".form-grid");
    const headings = personalDetailsSection.querySelectorAll("h3");
    formGrids.forEach((grid) => (grid.style.display = "grid"));
    headings.forEach((heading) => (heading.style.display = "block"));
  }
  showStep(1);
  update();
  // --- Wait until visa cards appear in DOM ---
  const observer = new MutationObserver(() => {
  const card = document.querySelector(`[data-selected-variant='${traveller.variantId}']`);
  if (card) {
    $(".visa-card-active").removeClass("visa-card-active");
    card.classList.add("visa-card-active");
    console.log("Visa card activated using MutationObserver:", card);
    observer.disconnect(); 
     }

     });

     observer.observe(document.body, {
     childList: true,
     subtree: true
    });

   // Scroll to top
   window.scrollTo({ top: 0, behavior: "smooth" });
}


function deleteTraveller(index) {
  if (index < 0 || index >= travellers.length) return;

  const traveller = travellers[index];
  const confirmed = confirm(
    `Are you sure you want to delete traveller:\n${traveller.travellerFirstName} ${traveller.travellerLastName}?`
  );

  if (confirmed) {
    travellers.splice(index, 1);

    // Update display
    if (travellers.length > 0) {
      updateOngoingApplicationCard();
    } else {
      // Hide ongoing card if no travellers
      const savedProgressCard = document.getElementById("savedProgressCard");
      if (savedProgressCard) {
        savedProgressCard.classList.add("hidden");
      }
    }

    // Save progress
    saveProgress();

    alert("Traveller deleted successfully!");
  }
}
function clearFormData() {
  console.log("CLEAR Form is running ");
  // Clear all form inputs
  document.getElementById("title").value = "";
  document.getElementById("firstName").value = "";
  document.getElementById("middleName").value = "";
  document.getElementById("lastName").value = "";
  document.getElementById("gender").value = "";
  document.getElementById("dob").value = "";
  document.getElementById("occupation").value = "";
  document.getElementById("mobile").value = "";
  document.getElementById("email").value = "";
  document.getElementById("passportNumber").value = "";
  document.getElementById("passportExpiry").value = "";
  document.getElementById("travelStartDate").value = "";
  document.getElementById("travelEndDate").value = "";
   //Clearing number of days
   document
  .querySelectorAll('#purposeOfVisitSection .right input[type="radio"]')
  .forEach(radio => radio.checked = false);
   document.querySelectorAll(".photo-preview img").forEach(img => {
  if (img.src.startsWith("blob:") || img.src.startsWith("data:")) {
    img.src = img.dataset.placeholder;
   }
    });

  document.querySelectorAll('.photo-upload input[type="file"]').forEach(input => {
  input.value = "";  
});
   document.querySelectorAll("#visaTypeSection .visa-card").forEach(card=> card.classList.remove("visa-card-active"))
  // Clear file inputs
  const flightFile = document.getElementById("flightFile");
  const hotelFile = document.getElementById("hotelFile");
  // const bankFile = document.getElementById("bankFile");

  if (flightFile) flightFile.value = "";
  if (hotelFile) hotelFile.value = "";
  // if (bankFile) bankFile.value = "";

  // Clear uploaded files
  uploadedFiles = {
    passportFront: null,
    passportBack: null,
    travellerImage: null,
  };

  // Reset upload UI states
  resetPassportUpload(
    document.getElementById("passportFrontUpload"),
    "Upload Passport Front",
    "Upload the front page of your passport"
  );
  resetPassportUpload(
    document.getElementById("passportBackUpload"),
    "Upload Passport Back",
    "Upload the back page of your passport"
  );
  resetPassportUpload(
    document.getElementById("travelerPhotoUpload"),
    "Upload Photo",
    "Passport size photo (optional)"
  );

  // // Reset checkbox
  // const skipCheckbox = document.getElementById("skipPassportUpload");
  // if (skipCheckbox) {
  //   skipCheckbox.checked = false;
  // }

  // Hide personal details section
  const personalDetailsSection = document.getElementById(
    "personalDetailsSection"
  );
  if (personalDetailsSection) {
    personalDetailsSection.style.display = "none";
  }

  // Enable passport uploads
  const passportUploads = document.getElementById("passportUploads");
  if (passportUploads) {
    passportUploads.classList.remove("disabled");
  }

  // Enable traveler photo upload
  const travelerPhotoUpload = document.getElementById("travelerPhotoUpload");
  if (travelerPhotoUpload) {
    travelerPhotoUpload.classList.remove("disabled");
    travelerPhotoUpload.style.opacity = "1";
    travelerPhotoUpload.style.pointerEvents = "auto";
  }

  resetFlightUpload();
  resetHotelUpload();

  // Clear errors
  clearAuthErrors();

  // Reset API call flag
  window.passportDataFetched = false;
}

// Add real-time validation on field blur

document.addEventListener("DOMContentLoaded", function () {
  // Add real-time validation listeners
  const fieldsToValidate = [
    {
      id:"title",
      validator:validateName,
      message:"Please select the title"
    },
    {
      id:"occupation",
      validator:validateName,
      message:"Please select occupation"
    },
    {
      id: "firstName",
      validator: validateName,
      message: "First name should contain only letters (2-50 characters)",
    },
    {
      id: "lastName",
      validator: validateName,
      message: "Last name should contain only letters (2-50 characters)",
    },
    {
      id: "mobile",
      validator: validateMobile,
      message: "Please enter a valid 10-digit Indian mobile number",
    },
    {
      id: "email",
      validator: validateEmail,
      message: "Please enter a valid email address",
    },
    {
      id: "dob",
      validator: validateDateOfBirth,
      message: "Please enter a valid date of birth (age 18-100)",
    },
    {
      id: "passportNumber",
      validator: validatePassportNumber,
      message: "Passport number should be 6-10 alphanumeric characters",
    },
    {
      id: "passportExpiry",
      validator: validatePassportExpiry,
      message: "Passport should be valid for at least 6 months",
    },
    {
      id: "travelStartDate",
      validator: validateTravelStartDate,
      message: `Travel start date must be at least ${additionalDays} day(s) from today`,
    },
    {
      id: "travelEndDate",
      validator: validateTravelEndDate,
      message: `Travel end date must be after start date and at least ${additionalDays} day(s) from today`,
    },
  ];

  fieldsToValidate.forEach((field) => {
    const element = document.getElementById(field.id);
    if (element) {
      element.addEventListener("blur", () => {
        validateField(field.id, field.validator, field.message);
      });
    }
  });
});

// Initialize on page load if DOMContentLoaded has already fired
if (document.readyState === "loading") {
  // Do nothing, DOMContentLoaded will fire
} else {
  // DOMContentLoaded has already fired

  // calculate the minimum appointment days and store it in a variable so that the minimum date can be restricted

  showStep(1);
  update();
  const passportFrontUpload = document.getElementById("passportFrontUpload");
  const passportBackUpload = document.getElementById("passportBackUpload");
  const travelerPhotoUpload = document.getElementById("travelerPhotoUpload");

  if (passportFrontUpload) {
    handleUpload(passportFrontUpload, "Passport Front", "passportFront");
  }

  if (passportBackUpload) {
    handleUpload(passportBackUpload, "Passport Back", "passportBack");
  }

  if (travelerPhotoUpload) {
    handleUpload(
      travelerPhotoUpload,
      "Traveler Photo",
      "travellerImage",
      ".jpg,.jpeg,.png"
    );
  }
}
// Auth Modal Management
function showAuthModal(formType = "login") {
  const modal = document.getElementById("authModal");
  const modalTitle = document.getElementById("modalTitle");
  const loginForm = document.getElementById("loginForm");
  const signupForm = document.getElementById("signupForm");
  const otpForm = document.getElementById("otpForm");

  // Hide all forms first
  loginForm.classList.add("hidden");
  signupForm.classList.add("hidden");
  otpForm.classList.add("hidden");

  // Show the requested form
  if (formType === "login") {
    loginForm.classList.remove("hidden");
    modalTitle.textContent = "Login";
  } else if (formType === "signup") {
    signupForm.classList.remove("hidden");
    modalTitle.textContent = "Sign Up";
  } else if (formType === "otp") {
    otpForm.classList.remove("hidden");
    modalTitle.textContent = "Verify OTP";
  }

  modal.classList.add("active");
  document.body.style.overflow = "hidden";
}

function hideAuthModal() {
  const modal = document.getElementById("authModal");
  modal.classList.remove("active");
  document.body.style.overflow = "auto";

  // Clear all forms
  clearAuthForms();
}

function clearAuthForms() {
  // Clear login form
  document.getElementById("loginEmail").value = "";
  document.getElementById("loginPassword").value = "";
  clearAuthErrors();

  // Clear signup form
  document.getElementById("signupFirstName").value = "";
  document.getElementById("signupLastName").value = "";
  document.getElementById("signupEmail").value = "";
  document.getElementById("signupMobile").value = "";
  document.getElementById("signupPassword").value = "";
  document.getElementById("signupConfirmPassword").value = "";

  // Clear OTP form
  document.querySelectorAll(".otp-digit").forEach((input) => {
    input.value = "";
    input.classList.remove("filled", "error");
  });
}

function clearAuthErrors() {
  document.querySelectorAll(".error-message").forEach((error) => {
    error.textContent = "";
  });
  document.querySelectorAll(".error").forEach((field) => {
    field.classList.remove("error");
  });
}

// Validation Functions for Auth
function validateAuthField(fieldId, validationFn, errorMessage) {
  const field = document.getElementById(fieldId);
  const errorDiv = document.getElementById(fieldId + "Error");

  if (!field) return true;
 
  const isValid = validationFn(field.value);

  if (!isValid) {
    field.classList.add("error");
    if (errorDiv) errorDiv.textContent = errorMessage;
    return false;
  } else {
    field.classList.remove("error");
    if (errorDiv) errorDiv.textContent = "";
    return true;
  }
}

function validatePassword(value) {
  // Password should be at least 8 characters with at least one number and one letter
  return value.length >= 8 && /[0-9]/.test(value) && /[a-zA-Z]/.test(value);
}

function validateConfirmPassword(password, confirmPassword) {
  return password === confirmPassword && password.length > 0;
}

// Login Validation
function validateLoginForm() {
  let isValid = true;

  isValid &&= validateAuthField(
    "loginEmail",
    validateEmail,
    "Please enter a valid email address"
  );
  isValid &&= validateAuthField(
    "loginPassword",
    (v) => v.length > 0,
    "Password is required"
  );

  return isValid;
}

// Signup Validation
function validateSignupForm() {
  let isValid = true;

  isValid &&= validateAuthField(
    "signupFirstName",
    (v) => v.trim().length > 0,
    "First name is required"
  );
  isValid &&= validateAuthField(
    "signupLastName",
    (v) => v.trim().length > 0,
    "Last name is required"
  );
  isValid &&= validateAuthField(
    "signupEmail",
    validateEmail,
    "Please enter a valid email address"
  );
  isValid &&= validateAuthField(
    "signupPassword",
    validatePassword,
    "Password must be at least 8 characters with numbers and letters"
  );

  // Confirm password validation
  const password = document.getElementById("signupPassword").value;
  const confirmPassword = document.getElementById(
    "signupConfirmPassword"
  ).value;
  isValid &&= validateAuthField(
    "signupConfirmPassword",
    (v) => validateConfirmPassword(password, v),
    "Passwords do not match"
  );

  return isValid;
}

// OTP Input Handling
function setupOTPInputs() {
  const otpInputs = document.querySelectorAll(".otp-digit");

  otpInputs.forEach((input, index) => {
    input.addEventListener("input", (e) => {
      const value = e.target.value;

      if (!/^\d$/.test(value)) {
        e.target.value = "";
        return;
      }

      e.target.classList.add("filled");

      // Move to next input
      if (value && index < otpInputs.length - 1) {
        otpInputs[index + 1].focus();
      }
    });

    input.addEventListener("keydown", (e) => {
      // Handle backspace
      if (e.key === "Backspace" && !input.value && index > 0) {
        otpInputs[index - 1].focus();
      }

      // Handle paste
      if (e.key === "Delete") {
        input.value = "";
        input.classList.remove("filled");
      }
    });

    // Handle paste
    input.addEventListener("paste", (e) => {
      e.preventDefault();
      const paste = e.clipboardData.getData("text");
      const digits = paste.replace(/\D/g, "").split("");

      digits.forEach((digit, i) => {
        if (index + i < otpInputs.length) {
          otpInputs[index + i].value = digit;
          otpInputs[index + i].classList.add("filled");
        }
      });

      // Focus the next empty input or last input
      const nextIndex = Math.min(index + digits.length, otpInputs.length - 1);
      otpInputs[nextIndex].focus();
    });
  });
}

function getOTPValue() {
  const otpInputs = document.querySelectorAll(".otp-digit");
  return Array.from(otpInputs)
    .map((input) => input.value)
    .join("");
}

function setOTPError(message) {
  const errorDiv = document.getElementById("otpError");
  const otpInputs = document.querySelectorAll(".otp-digit");

  errorDiv.textContent = message;
  otpInputs.forEach((input) => {
    input.classList.add("error");
  });
}

function clearOTPError() {
  const errorDiv = document.getElementById("otpError");
  const otpInputs = document.querySelectorAll(".otp-digit");

  errorDiv.textContent = "";
  otpInputs.forEach((input) => {
    input.classList.remove("error");
  });
}

function resetOtpInputs() {
  document.querySelectorAll(".otp-digit").forEach(i => {
    i.value = "";
    i.classList.remove("filled", "error");
  });
  clearOTPError();
}

// Simulate API Calls (Replace with actual API calls)
function simulateLogin(email, password) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      // Simulate API response
      if (email.toLowerCase() === "deepakpant@matrix.in" && password === "Deepak123") {
        resolve({ success: true, user: { email, name: "Deepak Pant" } });
        $('#loginBtn').html('<span class="login-icon">👤</span> Deepak Pant');
        $('#loginBtn').attr('disabled', 'disabled');
        // fetchSavedTravellers();
      } else {
        reject({ message: "Invalid email or password" });
      }
    }, 1500);
  });
}

function simulateSignup(userData) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      // Simulate API response
      const existingEmails = ["existing@example.com"];
      if (existingEmails.includes(userData.email)) {
        reject({ message: "Email already exists" });
      } else {
        resolve({ success: true, message: "OTP sent successfully" });
      }
    }, 1500);
  });
}

function simulateOTPVerification(otp) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      // Simulate API response
      if (otp === "123456") {
        resolve({ success: true, message: "Account created successfully" });
      } else {
        reject({ message: "Invalid OTP. Please try again." });
      }
    }, 1000);
  });
}

// Event Listeners Setup
function setupAuthEventListeners() {
  // Login button
  document.getElementById("loginBtn").addEventListener("click", () => {
    showAuthModal("signup");
  });

  // Close modal
  document
    .getElementById("closeModal")
    .addEventListener("click", hideAuthModal);

  // Close modal on overlay click
  // document.getElementById("authModal").addEventListener("click", (e) => {
  //   if (e.target.id === "authModal") {
  //     hideAuthModal();
  //   }
  // });

  // Switch between forms
  document.getElementById("switchToSignup").addEventListener("click", (e) => {
    e.preventDefault();
    showAuthModal("signup");
    enableOtpSignupMode();
  });

  document.getElementById("switchToLogin").addEventListener("click", (e) => {
    e.preventDefault();
    showAuthModal("login");
  });

  // Form submissions
  // document.getElementById("loginForm").addEventListener("submit", async (e) => {
  //   e.preventDefault();

  //   if (!validateLoginForm()) return;

  //   const submitBtn = e.target.querySelector(".auth-btn");
  //   const originalText = submitBtn.textContent;

  //   try {
  //     submitBtn.classList.add("loading");
  //     submitBtn.disabled = true;

  //     const email = document.getElementById("loginEmail").value;
  //     const password = document.getElementById("loginPassword").value;

  //     const userData = await simulateLogin(email, password);

  //     // Success need to cahnge userData
  //     await handleLoginSuccess(email);
  //     // hideAuthModal();
  //     // alert('Login successful! Welcome back.');
  //   } catch (error) {
  //     document.getElementById("loginPasswordError").textContent = error.message;
  //   } finally {
  //     submitBtn.classList.remove("loading");
  //     submitBtn.disabled = false;
  //   }
  // });
  // In simulateLogin success:
  async function handleLoginSuccess(userEmail) {
    userLoggedIn = true;
    currentUser = { email: userEmail };
    console.log("User logged in with email:", userEmail);
    console.log("currentUser object:", currentUser);
    // If there was a pending proceed action
    hideAuthModal();

    if (window.pendingProceedToPayment) {
      window.pendingProceedToPayment = false;
      saveTravellerData();
    } else {
      alert("Login successful! Welcome back.");
      // Fetch saved travellers after login
      await fetchSavedTravellers();
    }
  }

  // Signup Form Submit
  signupForm.addEventListener("submit", async (e) => {
    e.preventDefault();  // NOW IT DEFINITELY WORKS

    $('#otp-id').val("");

    if (!validateSignupForm()) return;

    const submitBtn = signupForm.querySelector(".auth-btn");
    submitBtn.classList.add("loading");
    submitBtn.disabled = true;

    const payload = {
      firstName: signupFirstName.value.trim(),
      lastName: signupLastName.value.trim(),
      email: signupEmail.value.trim(),
      password: signupPassword.value,
    };

    try {
      const response = await sendOtpAPI(payload);

      if (!response.success) {
        signupEmailError.textContent = response.message;
        return;
      }

      $('#otp-id').val(response.otpId);

      showAuthModal("otp");

    } catch (err) {
      signupEmailError.textContent = err.message;
    } finally {
      submitBtn.classList.remove("loading");
      submitBtn.disabled = false;
    }
  });

  document.getElementById("signupForm").onsubmit = function(e) {
    e.preventDefault();
    return false;
  };

  document.getElementById("otpForm").addEventListener("submit", async (e) => {
    e.preventDefault();

    const otp = [...document.querySelectorAll(".otp-digit")].map(i => i.value).join("");
    if (otp.length !== 6) {
      setOTPError("Please enter all 6 digits");
      return;
    }

    const submitBtn = e.target.querySelector(".auth-btn");
    submitBtn.classList.add("loading");
    submitBtn.disabled = true;

    try {
      const verify = await verifyOtpAPI({
        otp: otp,
        otpId: $('#otp-id').val(),
        email: signupEmail.value.trim()
      });

      if (!verify.success) {
        setOTPError(verify.message);
        return;
      }

      hideAuthModal();

      // 🔥 RESTORE SHOPIFY DEFAULT SUBMIT
      signupForm.onsubmit = shopifyOriginalOnSubmit;

      // 🔥 SUBMIT SHOPIFY FORM
      signupForm.submit();

    } catch (err) {
      setOTPError(err.message);
    } finally {
      submitBtn.classList.remove("loading");
      submitBtn.disabled = false;
    }
  });



  async function verifyOtpAPI(payload) {
    return new Promise((resolve, reject) => {
      const bodyText = canonicalJSONString(payload);
      const timestamp = Math.floor(Date.now() / 1000);
      const apiEndPoint = API_CONFIG.VERIFY_OTP;
      const message = `POST|${apiEndPoint}|${timestamp}|${bodyText}`;

      const hashData = CryptoJS.HmacSHA256(message, API_CONFIG.SECRET)
        .toString(CryptoJS.enc.Hex);

      let formData = new FormData();
      for (let k in payload) formData.append(k, payload[k]);
      formData.append("hash_data", hashData);

      $.ajax({
        url: `${API_CONFIG.API_URL}${apiEndPoint}`,
        type: "POST",
        headers: {
          "X-API-Key": API_CONFIG.API_KEY,
          "X-Auth-Token": timestamp,
        },
        data: formData,
        processData: false,
        contentType: false,
        xhrFields: { withCredentials: true },

        success: resolve,
        error: (xhr) => {
          try { reject(JSON.parse(xhr.responseText)); }
          catch { reject({ message: xhr.responseText }); }
        }
      });
    });
  }




  // In simulateOTPVerification success (after signup):
  async function handleSignupSuccess(userEmail) {
    userLoggedIn = true;
    currentUser = { email: userEmail };
    console.log("User signed up with email:", userEmail);
    console.log("currentUser object:", currentUser);

    hideAuthModal();

    if (window.pendingProceedToPayment) {
      window.pendingProceedToPayment = false;
      saveTravellerData();
    } else {
      alert("Account created successfully!");
      // Fetch saved travellers after signup (probably empty for new users)
      await fetchSavedTravellers();
    }
  }

  // Resend OTP using the SEND_OTP API
  document.getElementById("resendOtp").addEventListener("click", async (e) => {
    e.preventDefault();

    const email = signupEmail.value.trim();
    if (!email) return;

    resetOtpInputs();

    try {
      const response = await sendOtpAPI({ email });
      if (response.otpId) document.getElementById("otp-id").value = response.otpId;

      if (response.success) showTempMessage("OTP resent successfully!");
      else showTempMessage(response.message || "Failed to resend OTP");

    } catch (err) {
      showTempMessage(err.message || "Server error");
    }

    document.querySelector(".otp-digit").focus();
  });


  // Setup OTP inputs
  setupOTPInputs();
}

async function sendOtpAPI(payload) {
  return new Promise((resolve, reject) => {
    // Ensure email at minimum
    if (!payload.email) {
      reject({ message: "Email is required" });
      return;
    }

    // Canonical JSON string (same as deleteTraveller)
    const bodyText = canonicalJSONString(payload);

    // Timestamp
    const timestamp = Math.floor(Date.now() / 1000);

    // API endpoint
    const apiEndPoint = API_CONFIG.SEND_OTP;
    const message = `POST|${apiEndPoint}|${timestamp}|${bodyText}`;

    console.log("SEND OTP - Signing message:", message);

    // HMAC Hash
    const hashData = CryptoJS.HmacSHA256(
      message,
      API_CONFIG.SECRET
    ).toString(CryptoJS.enc.Hex);

    console.log("SEND OTP - hash_data:", hashData);

    // Create FormData
    let formData = new FormData();
    for (let key in payload) {
      formData.append(key, payload[key]);
    }
    formData.append("hash_data", hashData);

    // AJAX Call
    $.ajax({
      url: `${API_CONFIG.API_URL}${apiEndPoint}`,
      type: "POST",
      headers: {
        "X-API-Key": API_CONFIG.API_KEY,
        "X-Auth-Token": timestamp,
      },
      data: formData,
      processData: false,
      contentType: false,
      xhrFields: { withCredentials: true },

      success: (resp) => {
        console.log("SEND OTP Success:", resp);
        resolve(resp);
      },
      error: (xhr) => {
        console.error("SEND OTP Error:", xhr.responseText);
        try {
          reject(JSON.parse(xhr.responseText));
        } catch (e) {
          reject({ message: xhr.responseText });
        }
      },
    });
  });
}


function showTempMessage(msg) {
  const el = document.createElement("div");
  el.className = "temp-toast";
  el.textContent = msg;

  document.body.appendChild(el);

  setTimeout(() => {
    el.classList.add("show");
  }, 10);

  setTimeout(() => {
    el.classList.remove("show");
    setTimeout(() => el.remove(), 300);
  }, 2500);
}

document.addEventListener("click", function (e) {
  if (e.target.classList.contains("auth-modal-close")) {
    resetOtpInputs();
    document.getElementById("otp-id").value = "";
  }
});


function proceedToFinalPayment() {
  if (travellers.length === 0) {
    alert("Please add at least one traveller before proceeding to payment.");
    return;
  }

  // Hide success message
  hideSuccessMessage();

  // Calculate total amount
  const totalAmount = traveller.reduce((sum, item) => sum + (item.price || 0), 0);

  const confirmed = confirm(
    `Total Amount: ₹${totalAmount.toLocaleString()}\n\nTravellers: ${
      travellers.length
    }\n\nProceed to payment?`
  );

  if (confirmed) {
    // Clear saved progress as application is being completed
    clearSavedProgress();

    // Here you would redirect to payment gateway or show payment screen
    alert(
      `Proceeding to payment gateway...\n\nTotal: ₹${totalAmount.toLocaleString()}\nTravellers: ${
        travellers.length
      }\n\n(Payment integration pending)`
    );

    // Example: Redirect to payment URL with all traveller IDs
    const travellerIds = travellers.map((t) => t.applicationId).join(",");
    // window.location.href = `/payment?amount=${totalAmount}&travellers=${travellers.length}&ids=${travellerIds}`;
  }
}

// Add to Cart function
async function addToCart() {
  const payload = {
    items: []
  };
  
  for (const traveller of travellers) {
    try {
      const properties = {
        "_travellerId": traveller.travellerId,
        "_travellerFirstName": traveller.travellerFirstName,
        "_travellerMiddleName": traveller.travellerMiddleName,
        "_travellerLastName": traveller.travellerLastName,
        "_travellerEmail": traveller.travellerEmail,
        "_travellerMobile": traveller.travellerMobile,
        "_passportNumber": traveller.passportNumber,
        "_dob": traveller.travellerDob,
        "_gender": traveller.gender,
        "_occupation": traveller.occupation,
        "_passportExpiry": traveller.passportExpiry,
        "_travelStartDate": traveller.travelStartDate,
        "_travelEndDate": traveller.travelEndDate,
        "_customerEmail": traveller.customerEmail,
        "_applicationId": traveller.applicationId,
        "_travellerTitle": traveller.travellerTitle,
        "Traveller Name": traveller.travellerFirstName + " " +traveller.travellerLastName,
        "Passport Number": traveller.passportNumber,
        "Date Of Birth": traveller.travellerDob,
        "Travel Start Date": traveller.travelStartDate,
        "Travel End Date": traveller.travelEndDate,
        "_selectedPrice": traveller.price,
        "_selectedVariant": traveller.variantId,
        "_visaFee": traveller.visaFee,
        "_govtFee": traveller.govtFee,
        "_serviceTax": traveller.serviceTax,
        "_matrixGovtFee": traveller.matrixGovtFee,
        "_matrixFee": traveller.matrixFee
      };
      payload['items'].push({
        id: traveller.variantId,
        quantity: 1,
        properties: properties
      })

    } catch (error) {
      console.error(`⚠️ Error adding traveller ${traveller.travellerId}`, error);
    }
  }

  const response = await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify(payload)
  });
  
  if (!response.ok) {
    const err = await response.json();
    console.error(`Failed to add to cart`, err);
    console.log("Some error occured, Please try later")
  } else {
    const data = await response.json();
    console.log(`Added traveller`, data);
    clearSavedProgress();
    clearFormData();
    travellers = [];
    window.location.href = '/cart';
  }
  // ✅ After all travellers added, redirect to cart page
  
}


// Initialize auth system when DOM is ready
document.addEventListener("DOMContentLoaded", function () {
  // Check for saved progress first
  const savedProgress = loadProgress();

  if (savedProgress) {
    // Show prompt to continue or start fresh with travellers
    setTimeout(() => {
      showProgressPrompt(savedProgress);
    }, 500); // Small delay to ensure DOM is fully loaded
  } else {
    showStep(1);
    update();
  }

  // Initialize passport upload handlers
  const passportFrontUpload = document.getElementById("passportFrontUpload");
  const passportBackUpload = document.getElementById("passportBackUpload");
  const travelerPhotoUpload = document.getElementById("travelerPhotoUpload");

  if (passportFrontUpload) {
    handleUpload(passportFrontUpload, "Passport Front", "passportFront");
  }

  if (passportBackUpload) {
    handleUpload(passportBackUpload, "Passport Back", "passportBack");
  }

  if (travelerPhotoUpload) {
    handleUpload(
      travelerPhotoUpload,
      "Traveler Photo",
      "travellerImage",
      ".jpg,.jpeg,.png"
    );
  }

  // Auto-save progress on form field changes
  const formInputs = document.querySelectorAll("input, select");
  formInputs.forEach((input) => {
    input.addEventListener("change", () => {
      clearTimeout(window.saveProgressTimeout);
      window.saveProgressTimeout = setTimeout(saveProgress, 1000);
    });
  });

  //  Fetch saved travellers if user is logged in
  if (userLoggedIn && currentUser?.email) {
    setTimeout(() => {
      fetchSavedTravellers();
    }, 500);
  }

  // Setup auth listeners
  setupAuthEventListeners();

  //  Setup continue with selected button
  //Just Putting the eventListner outside the function
});

const btnContinueWithSelected = document.getElementById("btnContinueWithSelected");

if (btnContinueWithSelected) {
  btnContinueWithSelected.addEventListener("click",continueWithSelectedTravellers);
}


// function initiatlisePage2(){
 
//   const $dropdownToggle = $("#dropdownToggle");

//   const $priceMenu = $("#priceMenu");
//   const $priceValue = $("#priceValue");

//   // Toggle dropdown visibility
//   $dropdownToggle.on("click", function(e) {
//     e.stopPropagation();
//     console.log("clicked");
//     $priceMenu.toggleClass("show");
//   });

//   // Update price on selection
//   $priceMenu.on("click", "li", function() {
//     $priceValue.text($(this).text());
//     $priceMenu.removeClass("show");
//   });

//   // Close dropdown on outside click
//   $(document).on("click", function() {
//     $priceMenu.removeClass("show");
//   });
// };
// initiatlisePage2();

// add active css to clicked visa card when clicked
$(document).on('click', '.visa-card', function() {
  $('.visa-card').removeClass('visa-card-active');
  $(this).addClass('visa-card-active');
  // $('.visa-card-active .dropdown-btn')[0].click();
   // Extract data attributes
    var minAge  = parseInt($(this).data('minimum-age'));   // e.g., 17
    var maxAge  = parseInt($(this).data('maximum-age'));   // e.g., 120
    var minAppt = parseInt($(this).data('minimum-appointment-days')) || 0;

    // ADD DOB MIN/MAX CONDITION BASED ON AGE

    // var today = new Date();

    // Max DOB = Today - minAge years
    var maxDob = new Date(today.getFullYear() - minAge, today.getMonth(), today.getDate());

    // Min DOB = Today - maxAge years
    var minDob = new Date(today.getFullYear() - maxAge, today.getMonth(), today.getDate());

    // $("#dob").attr("min", formatDate(minDob));
    // $("#dob").attr("max", formatDate(maxDob));

    // ADD PASSPORT EXPIRY CHECK = TODAY + 6 MONTHS

    var passportMin = new Date();
    passportMin.setMonth(passportMin.getMonth() + 6);

    $("#passportExpiry").attr("min", formatDate(passportMin));

    // ADD TRAVEL START DATE = TODAY + (MIN APPOINTMENT DAYS + 1) (Default 0 +1)

    // var travelMin = new Date();
    // travelMin.setDate(travelMin.getDate() + (minAppt + 1));

    // $("#travelStartDate").attr("min", formatDate(travelMin));
    // $("#travelEndDate").attr("min", formatDate(travelMin));
});

document.getElementById("terms-and-cond").addEventListener("click",()=>{
  document.querySelector('.term-and-cond').style.display="block"
}); 

$("#travelStartDate").on("change", function() {
    var selectedStart = new Date($(this).val());
    if (!isNaN(selectedStart.getTime())) {
        selectedStart.setDate(selectedStart.getDate() + 1); // must be greater
        $("#travelEndDate").attr("min", formatDate(selectedStart));
    }
});

function formatDate(d) {
    var month = (d.getMonth() + 1).toString().padStart(2, '0');
    var day   = d.getDate().toString().padStart(2, '0');
    return d.getFullYear() + "-" + month + "-" + day;
}

$(document).ready(function(){
  if (currentUser){
    if ( ($('#travelStartDate').val() == "") && localStorage.getItem("visaStartDate")){
      $('#travelStartDate').val( localStorage.getItem("visaStartDate") );
      localStorage.removeItem("visaStartDate");
    }
    if ( ($('#travelEndDate').val() == "") && localStorage.getItem("visaEndDate")){
      $('#travelEndDate').val( localStorage.getItem("visaEndDate") );
      localStorage.removeItem("visaEndDate");
    }
  }
  calculateMinStartDate();
  setDobLimits();
})


const dob=document.getElementById('dob').value;
const age=calculateAgeFromDOB(dob);
console.log("Age from DOB",age);
function calculateAgeFromDOB(dob) {
  const birthDate = new Date(dob);
  const today = new Date();

  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();

  // If birthday hasn't occurred yet this year, subtract 1
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }

  return age;
}

function calculateMinStartDate(){
  let minAppointmentDays = -1
  document.querySelectorAll(".visa-card").forEach(card => {
    if (card.dataset.minimumAppointmentDays){
      if ( minAppointmentDays<0 ){
        minAppointmentDays = Number(card.dataset.minimumAppointmentDays) || 0;
      }
      else if( (minAppointmentDays>=0 && Number(card.dataset.minimumAppointmentDays) < minAppointmentDays) ){
        minAppointmentDays = Number(card.dataset.minimumAppointmentDays)
      }
    }
    // const days = Number(card.dataset.minimumAppointmentDays);
    // minAppointmentDays = Math.min(minAppointmentDays, days);
  });
  const dateInput = document.querySelector("#travelStartDate");
  const todayDate = new Date();
  const minStartDate = new Date(todayDate);
  minStartDate.setDate(today.getDate() + minAppointmentDays);
  dateInput.min = minStartDate.toISOString().split("T")[0];
}

function setDobLimits(){
  var minAge  = 0;
  var maxAge  = 120;
  // ADD DOB MIN/MAX CONDITION BASED ON AGE
  var today = new Date();
  // Max DOB = Today - minAge years
  var maxDob = new Date(today.getFullYear() - minAge, today.getMonth(), today.getDate());
  // Min DOB = Today - maxAge years
  var minDob = new Date(today.getFullYear() - maxAge, today.getMonth(), today.getDate());
  $("#dob").attr("min", formatDate(minDob));
  $("#dob").attr("max", formatDate(maxDob));
}


$(document).ready(function () {

  const loginFlag = localStorage.getItem("redirectAfterLoginVisa");

  if (loginFlag === "true") {

    $('.show-all-price').css("display", "none");
    $('.custom-visa-container').css("display", "flex");

    localStorage.removeItem("redirectAfterLoginVisa");

  } else {

    $('.show-all-price').css("display", "block"); 
    $('.custom-visa-container').css("display", "none");
  }

});